import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import { AppConfiguration } from 'src/app/app.configuration';
import { ConfigurationService, TurnoService } from 'src/app/core';
import { CardPaymentFactory } from 'src/app/core/hardware/card-payment/cardPayment.factory';
import { CardPaymentType } from 'src/app/core/hardware/card-payment/cardPaymentType.enum';
import { ErrorToast } from 'src/app/core/toast/error.toast';
import * as xml2js from 'xml2js';
import {
  Albaran,
  AlbaranItem,
  DatosAlbaranTicketsProductos,
} from '../models/albaran.model';
import { DevolucionService } from './devolucion.service';
import { environment } from 'src/environments/pedrera/environment.development-pedrera';
import { TranslateService } from '../../../shared/services/translate.service';
import { PagoService } from '../../venta/services/pago.service';
import { SuccessToast } from 'src/app/core/toast/success.toast';
import { TokenManagerService } from 'src/app/core/auth/token-manager.service';

@Injectable({
  providedIn: 'root',
})
export class AlbaranService {
  anulacionTotal = new BehaviorSubject(false);
  private albaranSubject: BehaviorSubject<Albaran>;
  public albaran: Observable<any>;

  private albaranesSubject: BehaviorSubject<any>;
  public albaranes: Observable<any>;

  public carritoItemsList = ['test', 'cosa', 'asdf'];

  public anularDeshabilitado = false;
  public facturarDeshabilitado = false;
  conf: any;

  constructor(
    private http: HttpClient,
    private config: AppConfiguration,
    private turnoService: TurnoService,
    private devolucionService: DevolucionService,
    private configuration: ConfigurationService,
    private toast: ToastrService,
    private translate: TranslateService,
    private pagoService: PagoService,
    private tokenManager: TokenManagerService
  ) {
    this.albaranSubject = new BehaviorSubject(undefined);
    this.albaran = this.albaranSubject.asObservable();

    this.albaranesSubject = new BehaviorSubject(undefined);
    this.albaranes = this.albaranesSubject.asObservable();
  }


  public get albaranValue() {
    return this.albaranSubject.value;
  }

  setAlbaranValue(albaran) {
    this.albaranSubject.next(albaran);
  }

  public get albaranesValue() {
    return this.albaranSubject.value;
  }

  setAlbaranesValue(albaranes) {
    this.albaranesSubject.next(albaranes);
  }

  buscar(terms: Observable<any>) {
    return terms
      .pipe(debounceTime(400))
      .pipe(distinctUntilChanged())
      .pipe(
        switchMap((input) =>
          this.getAlbaran(
            input.tpvId !== ''
              ? input.tpvId
              : this.configuration.datosTPVPathValue.pkId,
            '',
            input.filtrarCentro
              ? this.configuration.datosTPVPathValue.ClaveCentro
              : '',
            input.query
          )
        )
      );
  }

  buscar2(terms: Observable<any>) {
    return terms
      .pipe(debounceTime(400))
      .pipe(
        switchMap((input: any) =>
          this.getAlbaran(
            this.configuration.datosTPVPathValue.pkId,
            '',
            input.filtrarCentro
              ? this.configuration.datosTPVPathValue.ClaveCentro
              : '',
            input.value
          )
        )
      );
  }

  anularAlbaranTarjeta(Identificador, NumAlbaran) {
    console.log({
      action: 'anularAlbaranTarjeta',
      Identificador,
      NumAlbaran,
      albaranValue: this.albaranValue,
      conf: this.configuration.appConfig.value,
    });
    this.conf = this.configuration.appConfig.value;
    let body: any;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    // Defensive guard for mocked/incomplete contexts: avoid runtime crash when
    // card rollback is requested without loaded invoice/card data.
    if (!this.albaranValue || !this.albaranValue.PagoCCInfo) {
      console.warn('[AlbaranService] anularAlbaranTarjeta: missing albaranValue/PagoCCInfo, skipping card rollback', {
        Identificador,
        NumAlbaran,
        albaranValue: this.albaranValue,
      });
      return of({
        success: false,
        skipped: true,
        reason: 'missing_albaran_or_card_info',
      });
    }
    if (this.albaranValue.PagoCCInfo.TieneLectorElectronico === 'False') {
      body = {
        mediosPago:
          this.conf.DatosResult.AppConfigJsonPago.PagoMultiple !== '1' ||
          this.albaranValue.AlbaranFOPs.length > 0
            ? this.generarMediosPagoVentaAnulacion()
            : this.devolucionService
                .generarMediosPagoVenta()
                .filter(
                  (fop) =>
                    fop.Importe < 0 || (fop.Importe == 0 && fop.FOP === 'CC')
                ),
        ConexionIacpos: conexionId,
        VentaOrigenId: this.albaranValue.pkId,
        VentaOrigenTieneCC: this.albaranValue.TienePagoCC,
        Identificador: Identificador,
        NumAlbaran: NumAlbaran,
        // VentaOrigenImporteCC: this.albaranValue.AlbaranFOPs.find( fop => fop.FOP === 'CC').Importe,

        //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
        // UsuarioID: this.albaranValue.UsuarioId,
        // TPVId: this.albaranValue.TPVId,
        UsuarioID: this.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
        TurnoId: this.turnoService.turnoValue.pkid,
        TPVId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
        Facturado: this.albaranValue.Facturado,
        SerieFactura: this.albaranValue.SerieFactura,
        NumFacturaId: this.albaranValue.NumFacturaId,
        CambioRecibido: this.albaranValue.CambioRecibido.replace(',', '.'),
        CambioDevuelto: this.albaranValue.CambioDevuelto.replace(',', '.'),
        MantenerFechaOri: 0,
        Localizador: this.albaranValue.ClaveReserva,
        Fecha: this.albaranValue.FechaHoraEntrada,
        contadorAlbaranes: {
          // TpvId: this.albaranValue.TPVId
          TpvId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
        },
        contadorOperacionesTarjeta: {
          // TpvId: this.albaranValue.TPVId
          TpvId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
        },
        cajasTurno_cantidad: this.generarCajasTurnoCantidadAnulacion(),
        aforosVenta: this.generarAforosVenta(),
        resumenTurno: {
          TurnoId: this.turnoService.turnoValue.pkid,
          // UsuarioId: this.albaranValue.UsuarioId,
          // TPVId: this.albaranValue.TPVId,
          UsuarioId: this.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
          TPVId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
          NumEntradas: Number.parseInt(this.albaranValue.NumEntradas, 10) * -1,
          IngresoAlbaranes:
            Number.parseFloat(this.albaranValue.TotalPagar.replace(',', '.')) *
            -1,
        },
        OperacionesTarjeta: {
          FechaHora: '',
          Importe: this.albaranValue.AlbaranFOPs.find((fop) => fop.FOP === 'CC')
            .Importe,
          //this.devolucionService.carritoDevolucion.precioTotal,
          TipoOperacion: '02',
          NumAutorizacion2oBloque: '',
          CodigoAceptacion: 'AC',
          TextoInformativo: 'OPERACION ACEPTADA',
          TextoReservadoControlador: '',
          NumTarjeta: this.albaranValue.PagoCCInfo.NumTarjeta,
          FechaCaducidad: this.albaranValue.PagoCCInfo.FechaCaducidad,
          NumAutorizacion1erBloque: '',
          FechaConciliacion1erBloque: '',
          FechaConciliacion2oBloque: '',
          TieneLector: '0',
          LecturaElectronica: '0',
          PresenciaTitular: '1',
          TarjetaPresente: '1',
          TipoTarjeta: '',
          Identificador: Identificador,
          /*           NumOperacion: result.Operaciones.comunicacionContable[0]
            .resultadoComunicacion[0].pedido
            ? result.Operaciones.comunicacionContable[0]
              .resultadoComunicacion[0].pedido[0]
            : undefined,
          IdentEstablecimiento2oBloque: infoTarjeta.TarjetaMCPComercio,
          DatosAdicionales: result.Operaciones.comunicacionContable[0]
            .resultadoComunicacion[0].identificadorRTS
            ? result.Operaciones.comunicacionContable[0]
              .resultadoComunicacion[0].identificadorRTS[0]
            : undefined,
          DatosAdicionalesPrivados: infoTarjeta.TarjetaMCPTerminal, */
          CodigoAccion: '',
          PedidoBase: this.albaranValue.PagoCCInfo.NumOperacion,
          CodigoClienteID: '',
          NumReimpresiones: '',
          IntroduccionManual: '',
          DivisaId: '',
        },
        // Agregar motivo de devolución si existe
        MotivoDevolucionId: this.devolucionService.motivoDevolucionValue || "0",
      };

      return this.http
        .post(
          `${this.config.getConfig('API_URL')}api/VentaTaquilla/AnularVenta`,
          body
        )
        .pipe(
          map((res: any) => {
            if (!res.DatosResult) {
              this.toast.error('', res.Mensajes[0].DescripcionMensaje, {
                toastComponent: ErrorToast,
                timeOut: 5000,
              });
              return {};
            }
            return res.DatosResult;
          })
        );
    } else if (this.albaranValue.PagoCCInfo.TieneLectorElectronico === 'True') {
      this.conf = this.configuration.appConfig.value;
      console.log({
        action: 'tieneLectorElectronico True',
        conf: this.conf,
      });
      if (
        this.conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'D'
      ) {
        this.toast.error(
          this.translate.instant('ERROR_NO_LECTOR_TARJETA'),
          'Error',
          {
            toastComponent: ErrorToast,
          }
        );
        return of({
          success: false
        });
      }
      const cardPaymentConnection = CardPaymentFactory.getCardPayment(
        CardPaymentType.PINPAD
      );
      const infoTarjeta =
        this.configuration.deviceConfiguration.AppConfigJsonTarjeta;

      const tipoPayment = infoTarjeta.TarjetaTipoComunicacion;
      const operacionVenta =
        infoTarjeta.TarjetaTipoComunicacion === 'JCC' ? 'Refund' : 'A';

      console.log({
        albaran: this.albaranValue,
      });
      try {
        let respuestaPagoVisa = cardPaymentConnection.pay(
          this.pad(this.configuration.datosTPVPathValue.pkId, 4),
          '2',
          '0',
          NumAlbaran,
          Identificador,
          operacionVenta,
          infoTarjeta.TarjetaTipoComunicacion,
          tipoPayment == 'JCC'
            ? this.albaranValue.AlbaranFOPs.find((fop) => fop.FOP === 'CC')
                .Importe
            : '0',
          tipoPayment == 'JCC'
            ? '0'
            : this.albaranValue.AlbaranFOPs.find((fop) => fop.FOP === 'CC')
                .Importe,
          this.albaranValue.TPVId,
          this.albaranValue.PagoCCInfo.NumTarjeta,
          this.albaranValue.PagoCCInfo.FechaCaducidad,
          this.albaranValue.PagoCCInfo.NumOperacion,
          this.albaranValue.PagoCCInfo.DatosAdicionales,
          infoTarjeta.TarjetaMCPTerminal,
          infoTarjeta.TarjetaMCPVersion,
          infoTarjeta.TarjetaMCPComercio,
          infoTarjeta.TarjetaMCPClave,
          infoTarjeta.TarjetaMCPPuertoCOM,
          '0',
          //Devolucion JCC
          this.albaranValue.PagoCCInfo.Reservado2oBloque,
          this.albaranValue.PagoCCInfo.TextoReservadoControlador
        );

        // let respuestaPagoVisa = "OK:{\"id\":89,\"SystemId\":\"0000106003\",\"Payload\":{\"CashierID\":\"\",\"CurrencyCode\":\"\",\"Length\":0,\"SessionId\":\"\",\"AdditionalInfo\":{\"amount\":\"2500\",\"accountNumber\":\"\",\"expirationDate\":\"\",\"validFrom\":\"\",\"origReferNumber\":\"\",\"authNo\":\"011514\",\"cvv2\":\"\",\"contractOrRoomNo\":\"\",\"startDate\":\"\",\"extTerminalId\":\"\",\"extMerchantId\":\"\",\"extReferenceNumber\":\"\",\"receiptContent\":\"\",\"prepareReceiptIndicator\":\"\",\"language\":\"\",\"currencyCode\":\"\",\"loyaltyRequestType\":\"\",\"loyaltyIdentification\":\"\",\"origLoyaltyReferenceNumber\":\"\",\"cashierId\":\"\",\"returnPanEncrypted\":\"\",\"genericLoyaltyFlag\":\"\",\"genericLoyaltyBins\":\"\",\"giftTransactionType\":\"\",\"origGiftReferenceNo\":\"\",\"supplyCvmResult\":\"\",\"bocLoyaltyItems\":\"\",\"password\":\"\",\"messageCode\":\"\",\"messageType\":\"\",\"length\":\"\",\"checkOutDate\":\"\",\"batchno\":\"\",\"agreementnumber\":\"\",\"agreementDate\":\"\",\"sessionId\":\"\",\"CashBackAmount\":\"\",\"eacaccountNumber\":\"\",\"eacPhoneNumber\":\"\",\"eacPaymentFlag\":\"\",\"eacBeneficiaryOutlet\":\"\",\"numberOfInstallments\":\"\",\"firstInstallmentDate\":\"\",\"binReceipt\":\"\",\"AdditionalAmount\":\"\",\"dccAlertSupport\":\"\",\"terminalNo\":\"\",\"tokenNo\":\"\",\"telephoneNo\":\"\",\"emailAddress\":\"\"}},\"Info\":{\"TerminalID\":\"\",\"StoreId\":\"\",\"Merchant\":\"\",\"PluginInfo\":{\"Name\":\"Printec\",\"Version\":\"1.0\",\"TimeoutRequest\":180000,\"DccAlertResponseCode\":[\"51\",\"54\"],\"JCCSupportedVersions\":[\"1.0\",\"1.2\"],\"Capabilities\":[\"Init\",\"Payment\",\"Status\",\"ping\",\"Refund\",\"Void\",\"Reversal\",\"PurchaseWithInstallments\",\"PreAuth\",\"CloseBatch\",\"PrintReceipt\",\"PrintDuplicateReceipt\",\"GetTotals\",\"Completion\",\"VoidPreAuth\",\"AccountVerification\"],\"OperationsMaps\":[{\"Ping\":\"ping\"},{\"Init\":\"init\"},{\"Payment\":\"00\"},{\"PreAuth\":\"01\"},{\"Refund\":\"02\"},{\"Reversal\":\"05\"},{\"PurchaseWithInstallments\":\"06\"},{\"Void\":\"04\"},{\"CloseBatch\":\"10\"},{\"PrintDuplicateReceipt\":\"09\"},{\"PrintReceipt\":\"30\"},{\"Completion\":\"03\"},{\"GetTotals\":\"12\"},{\"VoidPreAuth\":\"73\"},{\"AccountVerification\":\"74\"}],\"DelayBetweenRequests\":10000,\"EndOfReceiptTextResponse\":\"CARDHOLDER COPY\"},\"Version\":null,\"User\":\"\",\"Password\":\"\"},\"Results\":[{\"SequenceId\":\"1\",\"Response\":null,\"TransactionType\":\"Refund\",\"ErrorCode\":\"\",\"OperationID\":\"89\",\"Status\":\"Success\",\"ResponseCode\":\"00\",\"ResponseContent\":null,\"TransactionResponse\":{\"SystemId\":null,\"TransactionType\":\"02\",\"NOInstalments\":\"00\",\"NoOfPostdatedMonths\":\"00\",\"TerminalNo\":\"000110004936\",\"BatchNo\":\"005\",\"ResponseCode\":\"00\",\"FinalAmount\":\"25\",\"LoyaltyRedemptionIndicator\":null,\"ModifiedAmount\":\"\",\"RRNFinancialAuthorization\":null,\"ReceiptNo\":\"9680\",\"AuthCode\":\"011514\",\"AccountNumber\":\"3352\",\"ExpiryDate\":\"0000\",\"CardholderName\":null,\"DCCAmount\":\"0\",\"DCCCurrency\":null,\"DCCExchangeRateMarkUp\":\"0\",\"DCCMarkUpPercentage\":\"0\",\"DCCExchangeDateOfRate\":null,\"ResponseTextMessage\":null,\"CardProduct\":\"VISA\",\"HostResponse\":null,\"FirstInstallmentDate\":null,\"NetAmount\":\"0\",\"TransactionReceiptTicket\":\"JCCLink\\n\\n0001100-04-9-36  36005\\nREBECCA BLU             \\nANEXARTISIAS 43C              \\nNICOSIA     \\nVAT NO.  CY0073034\\n10/04/2025  18:29:59\\n\\n\\nAID: A0000000031010\\nVisa Debit   <9680> \\n****-****-****-3352\\n\\n\\nRETURN\\nJCC CONTACTLESS\\nAMOUNT  EUR25,00\\nI ACCEPT THE TRANSACTION\\n\\n\\nSIGN _______________________\\n\\nAUTH NO.:021799\\nVersions:V26.12-0000-L@3\\nMERCHANT COPY\\n\\n\\nJCCLink\\n\\n0001100-04-9-36  36005\\nREBECCA BLU             \\nANEXARTISIAS 43C              \\nNICOSIA     \\nVAT NO.  CY0073034\\n10/04/2025  18:29:59\\n\\n\\nAID: A0000000031010\\nVisa Debit   <9680> \\n****-****-****-3352\\n\\n\\nRETURN\\nJCC CONTACTLESS\\nAMOUNT  EUR25,00\\nAUTH NO.:021799\\nVersions:V26.12-0000-L@3\\nCARDHOLDER COPY\\n\\n\",\"BatchStatus\":null,\"CurrencyCode\":\"978\",\"LoyaltyPointsBalance\":\"0\",\"LoyaltyTransactionPoint\":\"0\",\"LoyaltyTransReferenceNo\":\"9680\",\"PanEncrypted\":null,\"Track2Data\":null,\"PINValue\":null,\"KilometresIndicator\":null,\"GiftBalance\":null,\"GiftTransRefNo\":\"9680\",\"CVMResults\":null,\"BOCLoyaltyItems\":null,\"IsBOCLoyaltyTransaction\":\"0\",\"BOCLoyaltyPointsEarned\":null,\"MerchantDiscount\":null,\"VoucherDiscount\":null,\"BOCRedemptionAmount\":null,\"CashbackAmount\":null,\"TokenNo\":null,\"EncryptedPan\":null,\"DateTime\":null,\"EntryMode\":null,\"POSVersion\":null,\"MerchantName\":null,\"Address\":null,\"PostalCode\":null,\"VATRegNo\":null,\"MCC\":null,\"SettleTransactionID\":null}}]}";

        this.conf = this.configuration.appConfig.value;
        if (tipoPayment !== 'JCC') {
          //PINPAD REDSYS
          const [tipoRespuesta, ...rest] = respuestaPagoVisa.trim().split(':');
          const respuestaXml = rest.join();
          const that = this;

          if (tipoRespuesta === 'OK') {
            xml2js.parseString(respuestaXml, function (err, result) {
              if (err !== null) {
                this.toast.success('Venta anulada', 'OK', {
                  toastComponent: SuccessToast,
                });
                return;
              }
              body = {
                ConexionIacpos: conexionId,
                VentaOrigenId: that.albaranValue.pkId,
                VentaOrigenTieneCC: that.albaranValue.TienePagoCC,
                Identificador: Identificador,
                NumAlbaran: NumAlbaran,
                // VentaOrigenImporteCC: this.albaranValue.AlbaranFOPs.find( fop => fop.FOP === 'CC').Importe,

                //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                // UsuarioID: that.albaranValue.UsuarioId,
                // TPVId: that.albaranValue.TPVId,
                UsuarioID: that.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                TurnoId: that.turnoService.turnoValue.pkid,
                TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                Facturado: that.albaranValue.Facturado,
                SerieFactura: that.albaranValue.SerieFactura,
                NumFacturaId: that.albaranValue.NumFacturaId,
                CambioRecibido: that.albaranValue.CambioRecibido.replace(
                  ',',
                  '.'
                ),
                CambioDevuelto: that.albaranValue.CambioDevuelto.replace(
                  ',',
                  '.'
                ),
                MantenerFechaOri: 0,
                Localizador: that.albaranValue.ClaveReserva,
                Fecha: that.albaranValue.FechaHoraEntrada,
                mediosPago:
                  that.conf.DatosResult.AppConfigJsonPago.PagoMultiple !==
                    '1' || that.albaranValue.AlbaranFOPs.length > 0
                    ? that.generarMediosPagoVentaAnulacion()
                    : that.devolucionService
                        .generarMediosPagoVenta()
                        .filter(
                          (fop) =>
                            fop.Importe < 0 ||
                            (fop.Importe == 0 && fop.FOP === 'CC')
                        ),
                contadorAlbaranes: {
                  // TpvId: that.albaranValue.TPVId
                  TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                },
                contadorOperacionesTarjeta: {
                  // TpvId: that.albaranValue.TPVId
                  TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                },
                cajasTurno_cantidad: that.generarCajasTurnoCantidadAnulacion(),
                aforosVenta: that.generarAforosVenta(),
                resumenTurno: {
                  TurnoId: that.turnoService.turnoValue.pkid,
                  // UsuarioId: that.albaranValue.UsuarioId,
                  // TPVId: that.albaranValue.TPVId,
                  UsuarioId: that.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                  TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                  NumEntradas:
                    Number.parseInt(that.albaranValue.NumEntradas, 10) * -1,
                  IngresoAlbaranes:
                    Number.parseFloat(
                      that.albaranValue.TotalPagar.replace(',', '.')
                    ) * -1,
                },
                OperacionesTarjeta: {
                  FechaHora: '',
                  Importe: that.albaranValue.AlbaranFOPs.find(
                    (fop) => fop.FOP === 'CC'
                  ).Importe, //.albaranValue.TotalPagar,
                  TipoOperacion: '02',
                  NumAutorizacion2oBloque: '',
                  CodigoAceptacion: 'AC',
                  TextoInformativo: 'OPERACION ACEPTADA',
                  TextoReservadoControlador: '',
                  NumTarjeta: that.albaranValue.PagoCCInfo.NumTarjeta,
                  FechaCaducidad: that.albaranValue.PagoCCInfo.FechaCaducidad,
                  NumAutorizacion1erBloque: '',
                  FechaConciliacion1erBloque: '',
                  FechaConciliacion2oBloque: '',
                  TieneLector: '1',
                  LecturaElectronica: '1',
                  PresenciaTitular: '1',
                  TarjetaPresente: '1',
                  TipoTarjeta: '',
                  Identificador: Identificador,
                  /*NumOperacion: result.Operaciones.comunicacionContable[0]
                    .resultadoComunicacion[0].pedido
                    ? result.Operaciones.comunicacionContable[0]
                        .resultadoComunicacion[0].pedido[0]
                    : undefined,
                  IdentEstablecimiento2oBloque: infoTarjeta.TarjetaMCPComercio,
                  DatosAdicionales: result.Operaciones.comunicacionContable[0]
                    .resultadoComunicacion[0].identificadorRTS
                    ? result.Operaciones.comunicacionContable[0]
                        .resultadoComunicacion[0].identificadorRTS[0]
                    : undefined,
                  DatosAdicionalesPrivados: infoTarjeta.TarjetaMCPTerminal,*/
                  CodigoAccion: '',
                  PedidoBase: that.albaranValue.PagoCCInfo.NumOperacion,
                  CodigoClienteID: '',
                  NumReimpresiones: '',
                  IntroduccionManual: '',
                  DivisaId: '',
                },
                // Agregar motivo de devolución si existe
                MotivoDevolucionId: that.devolucionService.motivoDevolucionValue || "0",
              };
            });

            return this.http
              .post(
                `${this.config.getConfig(
                  'API_URL'
                )}api/VentaTaquilla/AnularVenta`,
                body
              )
              .pipe(
                map((res: any) => {
                  if (!res.DatosResult) {
                    this.toast.error('', res.Mensajes[0].DescripcionMensaje, {
                      toastComponent: ErrorToast,
                      timeOut: 5000,
                    });
                    return {};
                  }
                  return res.DatosResult;
                })
              );
          }
          if (tipoRespuesta === 'KO') {
            xml2js.parseString(respuestaXml, (err, result) => {
              if (err) {
                that.toast.error(`[${err}`, 'Error', {
                  toastComponent: ErrorToast,
                });
                return;
              }
              that.toast.error(
                `[${result.Error[0].codigo[0]}] ${result.Error[0].mensaje[0]}`,
                'Error',
                { toastComponent: ErrorToast }
              );
              return;
            });
          }
          if (tipoRespuesta === 'ERR') {
            this.toast.error(respuestaXml, 'Error', {
              toastComponent: ErrorToast,
            });
            return of({});
          }
        } else {
          //PINPAD JCC

          try {
            const result =
              respuestaPagoVisa &&
              this.pagoService.parseJCCResponseString(respuestaPagoVisa);
            if (result) {
              if (result.Results[0].ResponseCode === '00') {
                this.toast.success(
                  this.translate.instant('JCC_RESPONSE_CODE_00') || 'Approved',
                  '',
                  {
                    toastComponent: SuccessToast,
                    timeOut: 15000,
                  }
                );

                const that = this;

                body = {
                  ConexionIacpos: conexionId,
                  VentaOrigenId: that.albaranValue.pkId,
                  VentaOrigenTieneCC: that.albaranValue.TienePagoCC,
                  Identificador: Identificador,
                  NumAlbaran: NumAlbaran,
                  // VentaOrigenImporteCC: this.albaranValue.AlbaranFOPs.find( fop => fop.FOP === 'CC').Importe,

                  //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                  // UsuarioID: that.albaranValue.UsuarioId,
                  // TPVId: that.albaranValue.TPVId,
                  UsuarioID: that.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                  TurnoId: that.turnoService.turnoValue.pkid,
                  TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                  Facturado: that.albaranValue.Facturado,
                  SerieFactura: that.albaranValue.SerieFactura,
                  NumFacturaId: that.albaranValue.NumFacturaId,
                  CambioRecibido: that.albaranValue.CambioRecibido.replace(
                    ',',
                    '.'
                  ),
                  CambioDevuelto: that.albaranValue.CambioDevuelto.replace(
                    ',',
                    '.'
                  ),
                  MantenerFechaOri: 0,
                  Localizador: that.albaranValue.ClaveReserva,
                  Fecha: that.albaranValue.FechaHoraEntrada,
                  mediosPago:
                    this.conf.DatosResult.AppConfigJsonPago.PagoMultiple !==
                      '1' || this.albaranValue.AlbaranFOPs.length > 0
                      ? this.generarMediosPagoVentaAnulacion()
                      : this.devolucionService
                          .generarMediosPagoVenta()
                          .filter(
                            (fop) =>
                              fop.Importe < 0 ||
                              (fop.Importe == 0 && fop.FOP === 'CC')
                          ),
                  contadorAlbaranes: {
                    // TpvId: that.albaranValue.TPVId
                    TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                  },
                  contadorOperacionesTarjeta: {
                    // TpvId: that.albaranValue.TPVId
                    TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                  },
                  cajasTurno_cantidad:
                    that.generarCajasTurnoCantidadAnulacion(),
                  aforosVenta: that.generarAforosVenta(),
                  resumenTurno: {
                    TurnoId: that.turnoService.turnoValue.pkid,
                    // UsuarioId: that.albaranValue.UsuarioId,
                    // TPVId: that.albaranValue.TPVId,
                    UsuarioId: that.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                    TPVId: that.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
                    NumEntradas:
                      Number.parseInt(that.albaranValue.NumEntradas, 10) * -1,
                    IngresoAlbaranes:
                      Number.parseFloat(
                        that.albaranValue.TotalPagar.replace(',', '.')
                      ) * -1,
                  },
                  OperacionesTarjeta: {
                    FechaHora: '',
                    Importe: that.albaranValue.AlbaranFOPs.find(
                      (fop) => fop.FOP === 'CC'
                    ).Importe, //.albaranValue.TotalPagar,
                    TipoOperacion: '02',
                    NumAutorizacion2oBloque: '',
                    CodigoAceptacion: 'AC',
                    TextoInformativo: 'OPERACION ACEPTADA',
                    TextoReservadoControlador: '',
                    NumTarjeta: that.albaranValue.PagoCCInfo.NumTarjeta,
                    FechaCaducidad: that.albaranValue.PagoCCInfo.FechaCaducidad,
                    NumAutorizacion1erBloque: '',
                    FechaConciliacion1erBloque: '',
                    FechaConciliacion2oBloque: '',
                    TieneLector: '1',
                    LecturaElectronica: '1',
                    PresenciaTitular: '1',
                    TarjetaPresente: '1',
                    TipoTarjeta: '',
                    Identificador: Identificador,
                    /*NumOperacion: result.Operaciones.comunicacionContable[0]
                      .resultadoComunicacion[0].pedido
                      ? result.Operaciones.comunicacionContable[0]
                          .resultadoComunicacion[0].pedido[0]
                      : undefined,
                    IdentEstablecimiento2oBloque: infoTarjeta.TarjetaMCPComercio,
                    DatosAdicionales: result.Operaciones.comunicacionContable[0]
                      .resultadoComunicacion[0].identificadorRTS
                      ? result.Operaciones.comunicacionContable[0]
                          .resultadoComunicacion[0].identificadorRTS[0]
                      : undefined,
                    DatosAdicionalesPrivados: infoTarjeta.TarjetaMCPTerminal,*/
                    CodigoAccion: '',
                    PedidoBase: that.albaranValue.PagoCCInfo.NumOperacion,
                    CodigoClienteID: '',
                    NumReimpresiones: '',
                    IntroduccionManual: '',
                    DivisaId: '',
                  },
                  // Agregar motivo de devolución si existe
                  MotivoDevolucionId: that.devolucionService.motivoDevolucionValue || "0",
                };

                return this.http
                  .post(
                    `${this.config.getConfig(
                      'API_URL'
                    )}api/VentaTaquilla/AnularVenta`,
                    body
                  )
                  .pipe(
                    map((res: any) => {
                      if (!res.DatosResult) {
                        this.toast.error(
                          '',
                          res.Mensajes[0].DescripcionMensaje,
                          {
                            toastComponent: ErrorToast,
                            timeOut: 5000,
                          }
                        );
                        return {};
                      }
                      return res.DatosResult;
                    })
                  );
              }
            }
          } catch (e) {
            this.toast.error(e, '', {
              toastComponent: ErrorToast,
              timeOut: 5000,
            });

            this.toast.error(e.message, 'Error', {
              toastComponent: ErrorToast,
            });
            return throwError(() => new Error(e));
          }
        }
      } catch (e) {
        console.error({
          action: 'anularAlbaranTarjeta',
          error: JSON.stringify(e),
          stack: JSON.stringify(e.stack),
          albaranValue: this.albaranValue,
          conf: this.conf,
        });

        this.toast.error(this.translate.instant('ERROR_INESPERADO'), 'Error', {
          toastComponent: ErrorToast,
        });
        return throwError(() => new Error(e));
      }
    }
    return of({
      success: false
    });
  }

  async anularAlbaran() {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    this.conf = this.configuration.appConfig.value;
    const body = {
      ConexionIacpos: conexionId,
      VentaOrigenId: this.albaranValue.pkId,
      VentaOrigenTieneCC: this.albaranValue.TienePagoCC,
      // VentaOrigenImporteCC: this.albaranValue.AlbaranFOPs.find( fop => fop.FOP === 'CC').Importe,

      //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
      // UsuarioID: this.albaranValue.UsuarioId,
      // TPVId: this.albaranValue.TPVId,
      TurnoId: this.turnoService.turnoValue.pkid,
      UsuarioID: this.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
      TPVId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
      Facturado: this.albaranValue.Facturado,
      SerieFactura: this.albaranValue.SerieFactura,
      NumFacturaId: this.albaranValue.NumFacturaId,
      CambioRecibido: 0.0,
      CambioDevuelto: 0.0,
      MantenerFechaOri: 0,
      Localizador: this.albaranValue.ClaveReserva,
      Fecha: this.albaranValue.FechaHoraEntrada,
      mediosPago:
        this.conf.DatosResult.AppConfigJsonPago.PagoMultiple !== '1' ||
        this.albaranValue.AlbaranFOPs.length > 0
          ? this.generarMediosPagoVentaAnulacion()
          : this.devolucionService
              .generarMediosPagoVenta()
              .filter(
                (fop) =>
                  fop.Importe < 0 || (fop.Importe == 0 && fop.FOP === 'CA')
              ),
      contadorAlbaranes: {
        // TpvId: this.albaranValue.TPVId
        TpvId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
      },
      contadorOperacionesTarjeta: {
        // TpvId: this.albaranValue.TPVId
        TpvId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
      },
      cajasTurno_cantidad: this.generarCajasTurnoCantidadAnulacion(),
      aforosVenta: this.generarAforosVenta(),
      resumenTurno: {
        TurnoId: this.turnoService.turnoValue.pkid,
        // UsuarioId: this.albaranValue.UsuarioId,
        // TPVId: this.albaranValue.TPVId,
        UsuarioId: this.turnoService.turnoValue.UsuarioId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
        TPVId: this.turnoService.turnoValue.TpvId, //Yaribel 20201126  Modificamos la inicialización tal como solicita la documentacion del api
        NumEntradas: Number.parseInt(this.albaranValue.NumEntradas, 10) * -1,
        IngresoAlbaranes:
          Number.parseFloat(this.albaranValue.TotalPagar.replace(',', '.')) *
          -1,
      },
      // Agregar motivo de devolución si existe
      MotivoDevolucionId: this.devolucionService.motivoDevolucionValue || "0",
    };
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/VentaTaquilla/AnularVenta`,
        body
      )
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            this.toast.error('', res.Mensajes[0].DescripcionMensaje, {
              toastComponent: ErrorToast,
              timeOut: 5000,
            });
            return {};
          }
          return res.DatosResult;
        })
      )
      .toPromise();
  }

  // TODO
  async devolucionParcial(entradas) {
    const body = this.generarPeticionDevolucionParcial(entradas);
    console.log('🔄 [API DEVOLUCION] Petición a DevolucionParcial:', body);
    return this.http
      .post(
        `${this.config.getConfig('API_URL')}api/VentaTaquilla/DevolucionParcial`,
        body
      )
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            this.toast.error('', res.Mensajes[0].DescripcionMensaje, {
              toastComponent: ErrorToast,
              timeOut: 5000,
            });
            return {};
          }
          return res;
        })
      )
      .toPromise();
  }

  devolucionParcialTarjeta(entradas, Identificador, NumAlbaran) {
    this.conf = this.configuration.appConfig.value;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    let body: any;
    if (this.albaranValue.PagoCCInfo.TieneLectorElectronico === 'False') {
      body = this.generarPeticionDevolucionParcial(entradas, Identificador, NumAlbaran);

      // console.log('body devolucion parcial tarjeta::', body);

      return this.http
        .post(
          `${this.config.getConfig('API_URL')}api/VentaTaquilla/DevolucionParcial`,
          body
        )
        .pipe(
          map((res: any) => {
            if (!res.DatosResult) {
              this.toast.error('', res.Mensajes[0].DescripcionMensaje, {
                toastComponent: ErrorToast,
                timeOut: 5000,
              });
              return {};
            }
            return res;
          })
        );
    } else if (this.albaranValue.PagoCCInfo.TieneLectorElectronico === 'True') {
      if (
        this.conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'D'
      ) {
        this.toast.error('No hay lector de tarjeta', 'Error', {
          toastComponent: ErrorToast,
        });
        return of({
          DatosResult: null,
        }); // Return an empty observable if no card reader is available
      }
    }
    const cardPaymentConnection = CardPaymentFactory.getCardPayment(
      CardPaymentType.PINPAD
    );
    const infoTarjeta =
      this.configuration.deviceConfiguration.AppConfigJsonTarjeta;
    try {
      const respuestaPagoVisa = cardPaymentConnection.pay(
        this.pad(this.configuration.datosTPVPathValue.pkId, 4),
        '2',
        '0',
        NumAlbaran,
        Identificador,
        'D',
        infoTarjeta.TarjetaTipoComunicacion,
        '0',
        //this.albaranValue.TotalPagar,
        //this.devolucionService.carritoDevolucion.precioTotal.toString(),
        (
          '' +
          (this.devolucionService.pagoDesglosadoValue.pinpad +
            this.devolucionService.pagoDesglosadoValue.datafono)
        ).replace('.', ','),
        this.albaranValue.TPVId,
        this.albaranValue.PagoCCInfo.NumTarjeta,
        this.albaranValue.PagoCCInfo.FechaCaducidad,
        this.albaranValue.PagoCCInfo.NumOperacion,
        this.albaranValue.PagoCCInfo.DatosAdicionales,
        infoTarjeta.TarjetaMCPTerminal,
        infoTarjeta.TarjetaMCPVersion,
        infoTarjeta.TarjetaMCPComercio,
        infoTarjeta.TarjetaMCPClave,
        infoTarjeta.TarjetaMCPPuertoCOM,
        '0'
      );
      const [tipoRespuesta, ...rest] = respuestaPagoVisa.split(':');
      const respuestaXml = rest.join();
      const that = this;
      if (tipoRespuesta === 'OK') {
        //this.toast.error('Todo OK', 'OK', { toastComponent: ErrorToast });
        xml2js.parseString(respuestaXml, function (err, result) {
          if (err !== null) {
            // this.toast.error('Todo OK', 'OK', {
            //   toastComponent: ErrorToast
            // });
            return;
          }
          body = that.generarPeticionDevolucionParcial(entradas, Identificador, NumAlbaran, undefined, undefined, infoTarjeta.TarjetaMCPComercio, infoTarjeta.TarjetaMCPTerminal);
        });

        // console.log('body devolucion parcial tarjeta tipo respuesta OK::', body);
        return this.http
          .post(
            `${this.config.getConfig(
              'API_URL'
            )}api/VentaTaquilla/DevolucionParcial`,
            body
          )
          .pipe(
            map((res: any) => {
              if (!res.DatosResult) {
                this.toast.error('', res.Mensajes[0].DescripcionMensaje, {
                  toastComponent: ErrorToast,
                  timeOut: 5000,
                });
                return {};
              }
              return res;
            })
          );
      }
      if (tipoRespuesta === 'KO') {
        xml2js.parseString(respuestaXml, (err, result) => {
          if (err) {
            that.toast.error(`[${err}`, 'Error', {
              toastComponent: ErrorToast,
            });
            return;
          }
          that.toast.error(
            `[${result.Error[0].codigo[0]}] ${result.Error[0].mensaje[0]}`,
            'Error',
            { toastComponent: ErrorToast }
          );
          return;
        });
      }
      if (tipoRespuesta === 'ERR') {
        this.toast.error(respuestaXml, 'Error', { toastComponent: ErrorToast });
        return of({
          DatosResult: null,
        }); // Return an empty observable if there is an error
      }
      return of({
        DatosResult: null,
      }); // Return an empty observable if no response is received
    } catch (e) {
      console.error(e);
      this.toast.error(this.translate.instant('ERROR_INESPERADO'), 'Error', {
        toastComponent: ErrorToast,
      });
      return of({
        DatosResult: null,
      }); // Return an empty observable if an unexpected error occurs
    }
  }

  getUltimoAlbaran(idTpv) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPVId: idTpv,
      ClaveCentro: this.configuration.appConfig.value.DatosResult
        .AppConfigJsonVentaGestionar.FiltrarCentro
        ? this.configuration.datosTPVPathValue.ClaveCentro
        : '',
      NumAlbaran: '',
      Pagina: '1',
      NumeroRegistros: '1',
    };

    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetDatosAlbaran`, body)
      .pipe(
        map((res: any) => {
          if (res.DatosResult === null) {
            // Preservar el NumAlbaran original para permitir navegación
            const currentAlbaran = this.albaranValue;
            this.setAlbaranValue({ 
              noData: true, 
              NumAlbaran: currentAlbaran ? currentAlbaran.NumAlbaran : '' 
            });
            return null;
          }

          //<<Yaribel 20210217  Añadimos filtro para que no se nos dupliquen las entradas
          if (
            res.DatosResult &&
            res.DatosResult.ListadoAlbaranInfo[0] &&
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems
          ) {
            let newAlbaranItems: AlbaranItem[] = [];
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems.forEach(
              (element) => {
                let datos: AlbaranItem = newAlbaranItems.find(
                  (item) =>
                    item.ItemId === element.ItemId &&
                    item.TipoProducto === element.TipoProducto &&
                    item.PrecioUnidad === element.PrecioUnidad
                );
                if (datos === null || datos === undefined) {
                  const nuevo = { ...element, Contactos: [] };
                  nuevo.Contactos.push(element.idContacto);
                  newAlbaranItems.push(nuevo);
                } else {
                  datos.Cantidad = +datos.Cantidad + +element.Cantidad + '';
                  datos.CantidadMaxima =
                    +datos.CantidadMaxima + +element.CantidadMaxima + '';
                  datos.PrecioTotal =
                    Number.parseFloat(datos.PrecioTotal.replace(',', '.')) +
                    Number.parseFloat(element.PrecioTotal.replace(',', '.')) +
                    '';
                }
              }
            );
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems =
              newAlbaranItems;
          }
          // Yaribel 20210217 >>
          const albaranResult = {
            ...res.DatosResult.ListadoAlbaranInfo[0],
            noData: false,
            NombreTPV: this.turnoService.turnoValue.NombreTPV,
            IdTPV: this.turnoService.turnoValue.TpvId, // pkid del TPV actual
          };

          // Actualizamos el valor
          this.setAlbaranValue(albaranResult);
          return albaranResult;
        })
      );
  }

  getDatosAlbaranTicketsProductos(albaranId: string, numTicket?: string, tipoAccion?: number) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const token = JSON.parse(localStorage.getItem('currentToken'));
    const id = localStorage.getItem('credentialId');

    // Se verifica si this.albaranValue.AlbaranFOPs[0].AlbaranId tiene valor, sino se usa albaranId
    const albaranIdToUse =
      this.albaranValue.AlbaranFOPs &&
      this.albaranValue.AlbaranFOPs[0] &&
      this.albaranValue.AlbaranFOPs[0].AlbaranId
        ? this.albaranValue.AlbaranFOPs[0].AlbaranId
        : albaranId;

    const body: any = {
      ConexionIacpos: conexionId,
      ClienteApi: {
        Id: id,
        Token: token.token,
      },
      Identificador: this.albaranValue.NumVenta,
      AlbaranId: albaranIdToUse,
    };
    if (numTicket && numTicket.trim() !== '') {
      body.NumTicket = numTicket.trim();
    }
    if (tipoAccion !== undefined && tipoAccion !== null) {
      body.tipoAccion = tipoAccion;
    }

    console.log(body);

    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/GetDatosAlbaranTicketsProductos`,
        body
      )
      .pipe(
        map((res: any) => {
          return res.DatosResult as DatosAlbaranTicketsProductos;
        })
      );
  }

  getDatosAlbaranTicketsProductosArr(albaranId: string, numTicket?: string) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const token = JSON.parse(localStorage.getItem('currentToken'));
    const id = localStorage.getItem('credentialId');
    //UNO O EL OTRO
    const body: any = {
      ConexionIacpos: conexionId,
      ClienteApi: {
        Id: id,
        Token: token.token,
      },
      AlbaranId: albaranId,
    };
    // Añadir identificador del albarán si está en memoria
    if (this.albaranValue && this.albaranValue.NumVenta) {
      body.Identificador = this.albaranValue.NumVenta;
    }
    if (numTicket && numTicket.trim() !== '') {
      body.NumTicket = numTicket.trim();
    }
    return this.http
      .post(
        `${this.config.getConfig(
          'API_URL'
        )}api/GetDatosAlbaranTicketsProductos`,
        body
      )
      .pipe(
        map((res: any) => {
          return res.DatosResult as DatosAlbaranTicketsProductos;
        })
      );
  }

  datosAlbaran(numAlbaran) {
    return this.datosAlbaranConTPVId(numAlbaran, this.albaranValue.TPVId);
  }

  datosAlbaranConTPVId(numAlbaran, TPVId) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      // TPVId: this.albaranValue.TPVId,
      TPVId: TPVId,
      NumAlbaran: numAlbaran,
      Pagina: '1',
      NumeroRegistros: '1',
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetDatosAlbaran`, body)
      .pipe(
        map((res: any) => {
          if (res) {
            //<<Yaribel 20210217  Añadimos filtro para que no se nos dupliquen las entradas
            if (
              res.DatosResult &&
              res.DatosResult.ListadoAlbaranInfo[0] &&
              res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems
            ) {
              let newAlbaranItems: AlbaranItem[] = [];
              res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems.forEach(
                (element) => {
                  let datos: AlbaranItem = newAlbaranItems.find(
                    (item) =>
                      item.ItemId === element.ItemId &&
                      item.TipoProducto === element.TipoProducto &&
                      item.PrecioUnidad === element.PrecioUnidad
                  );
                  if (datos === null || datos === undefined) {
                    const nuevo = { ...element, Contactos: [] };
                    nuevo.Contactos.push(element.idContacto);
                    newAlbaranItems.push(nuevo);
                  } else {
                    datos.Cantidad = +datos.Cantidad + +element.Cantidad + '';
                    datos.CantidadMaxima =
                      +datos.CantidadMaxima + +element.CantidadMaxima + '';
                    datos.PrecioTotal =
                      +datos.PrecioTotal + +element.PrecioTotal + '';
                  }
                }
              );
              res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems =
                newAlbaranItems;
            }
            // Yaribel 20210217 >>
            return res;
          }
        })
      );
  }

  refrescarAlbaran(numAlbaran) {
    return this.refrescarAlbaranConTPVId(numAlbaran, this.albaranValue.TPVId);
  }

  refrescarAlbaranConTPVId(numAlbaran, TPVId) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      // TPVId: this.albaranValue.TPVId,
      TPVId: TPVId,
      NumAlbaran: numAlbaran,
      Pagina: '1',
      NumeroRegistros: '1',
    };
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetDatosAlbaran`, body)
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            // Preservar el NumAlbaran original para permitir navegación
            const currentAlbaran = this.albaranValue;
            this.setAlbaranValue({ 
              noData: true, 
              NumAlbaran: currentAlbaran ? currentAlbaran.NumAlbaran : '' 
            });
            return of(null);
          }
          // tslint:disable-next-line:max-line-length
          //<<Yaribel 20210217  Añadimos filtro para que no se nos dupliquen las entradas
          if (
            res.DatosResult &&
            res.DatosResult.ListadoAlbaranInfo[0] &&
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems
          ) {
            let newAlbaranItems: AlbaranItem[] = [];
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems.forEach(
              (element) => {
                let datos: AlbaranItem = newAlbaranItems.find(
                  (item) =>
                    item.ItemId === element.ItemId &&
                    item.TipoProducto === element.TipoProducto &&
                    item.PrecioUnidad === element.PrecioUnidad
                );
                if (datos === null || datos === undefined) {
                  const nuevo = { ...element, Contactos: [] };
                  nuevo.Contactos.push(element.idContacto);
                  newAlbaranItems.push(nuevo);
                } else {
                  datos.Cantidad = +datos.Cantidad + +element.Cantidad + '';
                  datos.CantidadMaxima =
                    +datos.CantidadMaxima + +element.CantidadMaxima + '';
                  datos.PrecioTotal =
                    +datos.PrecioTotal + +element.PrecioTotal + '';
                }
              }
            );
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems =
              newAlbaranItems;
          }
          // Yaribel 20210217 >>
          this.setAlbaranValue({
            ...res.DatosResult.ListadoAlbaranInfo[0],
            noData: false,
            NombreTPV: this.turnoService.turnoValue.NombreTPV,
            IdTPV: this.turnoService.turnoValue.TpvId, // Yaribel 20210315 Añadimos el pkid del tpv actual
          });
          return this.albaranValue;
        })
      );
  }

  getAlbaranes(idTpv) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPVId: idTpv,
      NumAlbaran: '',
      Pagina: '1',
      NumeroRegistros: '5',
    };
    this.http
      .post(`${this.config.getConfig('API_URL')}api/GetDatosAlbaran`, body)
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            this.setAlbaranesValue({ noData: true });
            return;
          }
          //<<Yaribel 20210217  Añadimos filtro para que no se nos dupliquen las entradas

          if (res.DatosResult && res.DatosResult.ListadoAlbaranInfo) {
            res.DatosResult.ListadoAlbaranInfo.forEach((Albaran) => {
              if (res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems) {
                let newAlbaranItems: AlbaranItem[] = [];
                Albaran.AlbaranItems.forEach((element) => {
                  let datos: AlbaranItem = newAlbaranItems.find(
                    (item) =>
                      item.ItemId === element.ItemId &&
                      item.TipoProducto === element.TipoProducto &&
                      item.PrecioUnidad === element.PrecioUnidad
                  );
                  if (datos === null || datos === undefined) {
                    const nuevo = { ...element, Contactos: [] };
                    nuevo.Contactos.push(element.idContacto);
                    newAlbaranItems.push(nuevo);
                  } else {
                    datos.Cantidad = +datos.Cantidad + +element.Cantidad + '';
                    datos.CantidadMaxima =
                      +datos.CantidadMaxima + +element.CantidadMaxima + '';
                    datos.PrecioTotal =
                      +datos.PrecioTotal + +element.PrecioTotal + '';
                  }
                });
                Albaran.AlbaranItems = newAlbaranItems;
              }
            });
          }

          // Yaribel 20210217 >>
          this.setAlbaranesValue({
            albaranes: res.DatosResult.ListadoAlbaranInfo,
            noData: false,
            pagina: body.Pagina,
            NumeroRegistros: body.NumeroRegistros,
            NombreTPV: this.turnoService.turnoValue.NombreTPV,
          });
        })
      )
      .subscribe();
  }

  private generarCajasTurnoCantidadAnulacion(): any[] {
    return this.turnoService.cajasValue
      .map((caja, index) => {
        const cajaExistente = this.albaranValue.AlbaranFOPs.find(
          (fop) => fop.FOP === caja.MedioPago
        );
        if (cajaExistente) {
          return {
            CajasTurnoId: caja.pkid,
            Cantidad: this.conversor(cajaExistente.Importe) * -1,
          };
        }
        return null;
      })
      .filter((el) => el != null);
  }

  // TODO: Si se puede hacer multiple habla que cambiarlo como el anterior
  private generarCajasTurnoCantidadDevolucion(): any[] {
    return this.turnoService.cajasValue
      .map((caja, index) => {
        const cajaExistente = this.albaranValue.AlbaranFOPs.find(
          (fop) => fop.FOP === caja.MedioPago
        );
        if (cajaExistente) {
          return {
            CajasTurnoId: caja.pkid,
            Cantidad: this.devolucionService.carritoDevolucion.precioTotal * -1,
          };
        }
        return null;
      })
      .filter((el) => el != null);
  }

  conversor(precio: string) {
    return Number.parseFloat(precio.replace(/,/, '.'));
  }

  // TODO
  getAlbaran(idTpv, numAlbaran, Centro, filtro?, pagina?, numeroRegistros?) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    
    // Validar que filtro no sea undefined, null o NaN
    let numAlbaranValue = '';
    if (filtro !== undefined && filtro !== null && !isNaN(filtro)) {
      numAlbaranValue = String(filtro);
    }
    
    const body = {
      ConexionIacpos: conexionId,
      TPVId: idTpv,
      NumAlbaran: numAlbaranValue,
      ClaveCentro: Centro ? Centro : '',
      Pagina: pagina || '1',
      NumeroRegistros: numeroRegistros || '1',
      TraerTicketsImpresion: '0',
      // Filtro: filtro
    };
    this.setAlbaranValue(undefined);
    return this.http
      .post(`${this.config.getConfig('API_URL')}api/GetDatosAlbaran`, body)
      .pipe(debounceTime(400))
      .pipe(
        map((res: any) => {
          if (!res.DatosResult) {
            // Preservar el NumAlbaran original para permitir navegación
            const currentAlbaran = this.albaranValue;
            this.setAlbaranValue({ 
              noData: true, 
              NumAlbaran: currentAlbaran ? currentAlbaran.NumAlbaran : numAlbaranValue 
            });
            return this.albaranValue;
          }
          //<<Yaribel 20210217  Añadimos filtro para que no se nos dupliquen las entradas
          if (
            res.DatosResult &&
            res.DatosResult.ListadoAlbaranInfo[0] &&
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems
          ) {
            let newAlbaranItems: AlbaranItem[] = [];
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems.forEach(
              (element) => {
                let datos: AlbaranItem = newAlbaranItems.find(
                  (item) =>
                    item.ItemId === element.ItemId &&
                    item.TipoProducto === element.TipoProducto &&
                    item.PrecioUnidad === element.PrecioUnidad
                );
                if (datos === null || datos === undefined) {
                  const nuevo = { ...element, Contactos: [] };
                  nuevo.Contactos.push(element.idContacto);
                  newAlbaranItems.push(nuevo);
                } else {
                  datos.Cantidad = +datos.Cantidad + +element.Cantidad + '';
                  datos.CantidadMaxima =
                    +datos.CantidadMaxima + +element.CantidadMaxima + '';
                  // datos.PrecioTotal = (+datos.PrecioTotal + +element.PrecioTotal) + '';
                  datos.PrecioTotal =
                    Number.parseFloat(datos.PrecioTotal.replace(',', '.')) +
                    Number.parseFloat(element.PrecioTotal.replace(',', '.')) +
                    '';
                }
              }
            );
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems =
              newAlbaranItems;
          }
          // Yaribel 20210217 >>
          this.setAlbaranValue({
            ...res.DatosResult.ListadoAlbaranInfo[0],
            noData: false,
            NombreTPV: this.turnoService.turnoValue.NombreTPV,
            IdTPV: this.turnoService.turnoValue.TpvId, // Yaribel 20210315 Añadimos el pkid del tpv actual
          });
          return this.albaranValue;
        })
      );
  }

  generarPeticionDevolucion(
    entradas,
    Identificador?,
    NumAlbaran?,
    pedido?,
    RTS?,
    MCPComercio?,
    MCPTerminal?
  ) {
    // TODO: b.	No se está inicializando correctamente el json de las devoluciones parciales.
    // Las entradas reducidas tienen comisión. En el atributo PrecioPagado tiene que incluir el PVP
    // sin comisión y lo está inicializando incluyéndola. Como la información no está almacenada
    // correctamente luego no la muestra bien. Hay que corregir la generación del json en las devoluciones
    // parciales en el aplicativo de Taquilla.
    this.conf = this.configuration.appConfig.value;
    let comisionTotal = 0;
    entradas.forEach((ticket) => {
      comisionTotal +=
        Number.parseFloat(ticket.itemInfo.Comision.replace(/,/, '.')) * -1 || 0;
    });
    this.devolucionService.comision = comisionTotal;
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const albaran = this.albaranValue;
    const body = {
      ConexionIacpos: conexionId,
      esVentaCC: albaran.TienePagoCC,
      contadorAlbaranes: {
        TpvId: this.turnoService.turnoValue.TpvId,
      },
      contadorOperacionesTarjeta: {
        TpvId: this.turnoService.turnoValue.TpvId,
      },
      CodigoCliente: albaran.CodigoClienteId,
      UsuarioID: this.turnoService.turnoValue.UsuarioId,
      TurnoId: this.turnoService.turnoValue.pkid,
      TPVId: this.turnoService.turnoValue.TpvId,
      TotalEntradas: this.generarEntradasDevolucion(entradas).length,
      PrecioBruto: this.generarBruto(entradas),
      DivisaId: albaran.DivisaId,
      TieneDescuento: albaran.TieneDto,
      Descuento: albaran.Descuento,
      GenerarFactura: albaran.GenerarFactura,
      FOP: albaran.FOP,
      FechaHoraEntrada: albaran.FechaHoraEntrada,
      Facturado: albaran.Facturado,
      SerieFactura: albaran.SerieFactura,
      NumFacturaId: albaran.NumFacturaId,
      EntradasConMotivo: albaran.HayEntradasConMotivo,
      SinFechaEntrada: albaran.SinFechaEntrada,
      EsDevolucion: 1,
      TotalDescuento: Number.parseFloat(albaran.TotalDescuento) * -1,
      FormaPagoId: albaran.FPId,
      TotalIVA: Number(
        (
          this.devolucionService.carritoDevolucion.precioTotal * -1 -
          this.devolucionService.carritoDevolucion.precioBase * -1
        ).toFixed(2)
      ),
      NumAlbaran: NumAlbaran ? NumAlbaran : '', // albaran.NumAlbaran,
      Identificador: Identificador ? Identificador : '', // albaran.NumVenta,
      // TotalPagar: this.devolucionService.carritoDevolucion.precioTotal * -1,
      TotalPagar: this.generarTotal(entradas),
      CambioRecibido:
        this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1' ||
        this.albaranValue.AlbaranFOPs.length < 2
          ? 0.0
          : Number.parseFloat(this.devolucionService.cambioValue) +
            Number.parseFloat(
              this.devolucionService
                .generarMediosPagoVenta()
                .find((x) => x.FOP == 'CA').Importe
              //albaran.CambioRecibido.replace(/,/, '.')
            ),
      CambioDevuelto:
        this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1' ||
        this.albaranValue.AlbaranFOPs.length < 2
          ? 0.0
          : Number.parseFloat(
              this.devolucionService.cambioValue
              //albaran.CambioDevuelto.replace(/,/, '.')
            ),
      DivisaRecibidaId: albaran.DivisaRecibidaId,
      DivisaDevueltaId: albaran.DivisaDevueltaId,
      NumAlbaranOrigen: albaran.pkId,
      Preventa: albaran.Preventa,
      BonoTexto: albaran.BonoTexto,
      GrupoTipoEntradaId: albaran.AlbaranItems[0].GrupoId,
      OrigenTPV: albaran.TPVId,
      OrigenAlbaran: albaran.NumAlbaran,
      mediosPago:
        this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1' ||
        this.albaranValue.AlbaranFOPs.length < 2
          ? this.generarMediosPagoVenta()
          : this.devolucionService
              .generarMediosPagoVenta()
              .filter(
                (fop) =>
                  fop.Importe < 0 || (fop.Importe == 0 && fop.FOP === 'CA')
              ),
      entradasVendidas: this.generarEntradasDevolucion(entradas),
      recintosVenta: this.generarRecintosVenta(entradas),
      aforosVenta: this.generarAforosDevolucion(entradas),
      motivosgrupos: albaran.AlbaranMotivos || [],
      cajasTurno_cantidad:
        this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1' ||
        this.albaranValue.AlbaranFOPs.length < 2
          ? this.generarCajasTurnoCantidadDevolucion()
          : this.devolucionService.generarCajasTurnoCantidad(),
      resumenTurno: this.generarResumenTurno(),
      contactoId: albaran.ContactoId,
      IdentificadorAlbaranOrigen: albaran.NumVenta,
      reservaVendida: {
        ClaveReserva: '',
        ReservaId: '',
      },
      OperacionesTarjeta:
        Identificador !== undefined
          ? {
              FechaHora: '',
              Importe:
                this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1' ||
                this.albaranValue.AlbaranFOPs.length < 2
                  ? this.devolucionService.carritoDevolucion.precioTotal
                  : this.devolucionService
                      .generarMediosPagoVenta()
                      .find((fop) => fop.FOP === 'CC').Importe * -1,
              TipoOperacion: '02',
              NumAutorizacion2oBloque: '',
              CodigoAceptacion: 'AC',
              TextoInformativo: 'OPERACION ACEPTADA',
              TextoReservadoControlador: '',
              NumTarjeta: this.albaranValue.PagoCCInfo.NumTarjeta,
              FechaCaducidad: this.albaranValue.PagoCCInfo.FechaCaducidad,
              NumAutorizacion1erBloque: '',
              FechaConciliacion1erBloque: '',
              FechaConciliacion2oBloque: '',
              TieneLector: '1',
              LecturaElectronica: '1',
              PresenciaTitular: '1',
              TarjetaPresente: '1',
              TipoTarjeta: '',
              NumOperacion: pedido,
              IdentEstablecimiento2oBloque: MCPComercio,
              DatosAdicionales: RTS,
              DatosAdicionalesPrivados: MCPTerminal,
              CodigoAccion: '',
              PedidoBase: '',
              CodigoClienteID: '',
              NumReimpresiones: '',
              IntroduccionManual: '',
              DivisaId: '',
            }
          : undefined,
    };
    return body;
  }

  /**
   * Genera la petición para la nueva API de DevolucionParcial
   * Mapea todos los elementos necesarios desde InsercionVenta
   */
  generarPeticionDevolucionParcial(entradas, Identificador?, NumAlbaran?, pedido?, RTS?, MCPComercio?, MCPTerminal?) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const albaran = this.albaranValue;
    this.conf = this.configuration.appConfig.value;
    
    console.log('🔄 [GENERAR PETICION] Generando petición para DevolucionParcial');
    console.log('🔄 [GENERAR PETICION] Albaran:', albaran);
    console.log('🔄 [GENERAR PETICION] Entradas:', entradas);

    // Calcular comisión total
    let comisionTotal = 0;
    entradas.forEach((ticket) => {
      comisionTotal +=
        Number.parseFloat(ticket.itemInfo.Comision.replace(/,/, '.')) * -1 || 0;
    });
    this.devolucionService.comision = comisionTotal;

    const body: any = {
      // Elementos básicos de la nueva API
      ConexionIacpos: conexionId,
      ClienteApi: {
        Id: localStorage.getItem('credentialId'),
        Token: JSON.parse(localStorage.getItem('currentToken')).token
      },
      plataforma: 2, // Taquilla Kore
      TurnoId: this.turnoService.turnoValue.pkid,
      TPVId: this.turnoService.turnoValue.TpvId,
      NumAlbaran: NumAlbaran || '', // Solo se usa si hay pago con tarjeta
      Identificador: Identificador || '', // Solo se usa si hay pago con tarjeta
      VentaOrigenId: albaran.pkId,
      TicketsListado: this.generarTicketsListado(entradas),
      mediosPago: this.generarMediosPagoDevolucionParcial(),
      CambioRecibido: this.calcularCambioRecibido(),
      CambioDevuelto: this.calcularCambioDevuelto(),
      MotivoDevolucionId: this.devolucionService.motivoDevolucionValue || "0",

      // Elementos adicionales mapeados desde InsercionVenta
      esVentaCC: albaran.TienePagoCC,
      contadorAlbaranes: {
        TpvId: this.turnoService.turnoValue.TpvId,
      },
      contadorOperacionesTarjeta: {
        TpvId: this.turnoService.turnoValue.TpvId,
      },
      CodigoCliente: albaran.CodigoClienteId,
      UsuarioID: this.turnoService.turnoValue.UsuarioId,
      TotalEntradas: this.generarEntradasDevolucion(entradas).length,
      PrecioBruto: this.generarBruto(entradas),
      DivisaId: albaran.DivisaId,
      TieneDescuento: albaran.TieneDto,
      Descuento: albaran.Descuento,
      GenerarFactura: albaran.GenerarFactura,
      FOP: albaran.FOP,
      FechaHoraEntrada: albaran.FechaHoraEntrada,
      Facturado: albaran.Facturado,
      SerieFactura: albaran.SerieFactura,
      NumFacturaId: albaran.NumFacturaId,
      EntradasConMotivo: albaran.HayEntradasConMotivo,
      SinFechaEntrada: albaran.SinFechaEntrada,
      EsDevolucion: 1,
      TotalDescuento: Number.parseFloat(albaran.TotalDescuento) * -1,
      FormaPagoId: albaran.FPId,
      TotalIVA: Number(
        (
          this.devolucionService.carritoDevolucion.precioTotal * -1 -
          this.devolucionService.carritoDevolucion.precioBase * -1
        ).toFixed(2)
      ),
      TotalPagar: this.generarTotal(entradas),
      DivisaRecibidaId: albaran.DivisaRecibidaId,
      DivisaDevueltaId: albaran.DivisaDevueltaId,
      NumAlbaranOrigen: albaran.pkId,
      Preventa: albaran.Preventa,
      BonoTexto: albaran.BonoTexto,
      GrupoTipoEntradaId: albaran.AlbaranItems[0]?.GrupoId || '',
      OrigenTPV: albaran.TPVId,
      OrigenAlbaran: albaran.NumAlbaran,
      entradasVendidas: this.generarEntradasDevolucion(entradas),
      recintosVenta: this.generarRecintosVenta(entradas),
      aforosVenta: this.generarAforosDevolucion(entradas),
      motivosgrupos: albaran.AlbaranMotivos || [],
      cajasTurno_cantidad: this.generarCajasTurnoCantidadDevolucion(),
      resumenTurno: this.generarResumenTurno(),
      contactoId: albaran.ContactoId,
      IdentificadorAlbaranOrigen: albaran.NumVenta,
      reservaVendida: {
        ClaveReserva: '',
        ReservaId: '',
      }
    };

    // Añadir OperacionesTarjeta solo si hay pago con tarjeta
    const pagoDesglosado = this.devolucionService.pagoDesglosadoValue || {};
    const tienePagoTarjeta = pagoDesglosado && (pagoDesglosado.pinpad > 0 || pagoDesglosado.datafono > 0);
    
    if (tienePagoTarjeta || Identificador !== undefined) {
      // CORRECCIÓN: Pasar el Identificador del albarán original (chIdentificador de la venta origen)
      // El Identificador debe ser el NumVenta del método GetDatosAlbaran de la venta origen
      // Según la documentación: Identificador = NumVenta del método GetDatosAlbaran (tbAlbaranes.chIdentificador venta origen)
      console.log('🔍 [IDENTIFICADOR] Buscando Identificador del albarán original:', {
        'albaran.NumVenta': albaran.NumVenta,
        'albaran.PagoCCInfo?.Identificador': albaran.PagoCCInfo?.Identificador,
        'Identificador (generado para devolución)': Identificador,
        'albaran completo': albaran
      });
      
      // CORRECCIÓN: Usar albaran.NumVenta que es el atributo de salida NumVenta del método GetDatosAlbaran
      const identificadorOrigen = albaran.NumVenta || 
                                   albaran.PagoCCInfo?.Identificador || 
                                   Identificador || 
                                   '';
      
      console.log('✅ [IDENTIFICADOR] Identificador origen seleccionado para OperacionesTarjeta:', identificadorOrigen);
      
      body.OperacionesTarjeta = this.generarOperacionesTarjetaDevolucionCompleta(
        identificadorOrigen, pedido, RTS, MCPComercio, MCPTerminal
      );
    }

    console.log('✅ [GENERAR PETICION] Petición generada:', body);
    console.log('🔍 [GENERAR PETICION] Verificación OperacionesTarjeta:', {
      'Existe OperacionesTarjeta': !!body.OperacionesTarjeta,
      'OperacionesTarjeta.Identificador': body.OperacionesTarjeta?.Identificador,
      'OperacionesTarjeta completo': body.OperacionesTarjeta
    });
    console.log('🔍 [GENERAR PETICION] Verificación CambioRecibido y mediosPago:', {
      'CambioRecibido': body.CambioRecibido,
      'CambioDevuelto': body.CambioDevuelto,
      'mediosPago': body.mediosPago,
      'Cantidad mediosPago': body.mediosPago?.length || 0
    });
    return body;
  }

  /**
   * Genera la lista de tickets a devolver
   * CASO 2: Prioriza TicketsListado del API para entradas conjuntas
   */
  private generarTicketsListado(entradas): string[] {
    console.log('🔄 [TICKETS LISTADO] Analizando entradas para generar tickets:');
    entradas.forEach((entrada, index) => {
      console.log(`🔄 [TICKETS LISTADO] Entrada ${index}:`, {
        NumTicket: entrada.NumTicket,
        NumOrden: entrada.NumOrden,
        numTickets: entrada.numTickets,
        tickets: entrada.tickets,
        'tickets[0].NumTicket': entrada.tickets?.[0]?.NumTicket,
        'tickets[0].NumOrden': entrada.tickets?.[0]?.NumOrden,
        'tickets[0].TicketsGestion': entrada.tickets?.[0]?.TicketsGestion,
        'tickets[0].TicketsListado': entrada.tickets?.[0]?.TicketsListado
      });
    });

    const tickets = [];
    
    entradas.forEach(entrada => {
      // PRIORIDAD 1: Usar TicketsListado si está disponible (más preciso para entradas conjuntas)
      if (entrada.tickets?.[0]?.TicketsListado && Array.isArray(entrada.tickets[0].TicketsListado)) {
        console.log(`🔄 [TICKETS LISTADO] Usando TicketsListado del API para entrada:`, entrada.tickets[0].TicketsListado);
        tickets.push(...entrada.tickets[0].TicketsListado);
      }
      // PRIORIDAD 2: Expandir rango si numTickets contiene "-" (fallback para entradas conjuntas)
      else if (entrada.numTickets && entrada.numTickets.includes('-')) {
        console.log(`🔄 [TICKETS LISTADO] Expandiendo rango numTickets:`, entrada.numTickets);
        const [inicio, fin] = entrada.numTickets.split('-').map(n => parseInt(n.trim()));
        for (let i = inicio; i <= fin; i++) {
          tickets.push(i.toString());
        }
      }
      // PRIORIDAD 3: Usar otros campos como fallback para entradas individuales
      else {
        const ticket = entrada.NumTicket || 
                      entrada.NumOrden || 
                      entrada.numTickets || 
                      entrada.tickets?.[0]?.NumTicket ||
                      entrada.tickets?.[0]?.NumOrden ||
                      entrada.tickets?.[0]?.TicketsGestion ||
                      '1';
        if (ticket && ticket !== null && ticket !== undefined) {
          console.log(`🔄 [TICKETS LISTADO] Usando ticket individual:`, ticket);
          tickets.push(ticket);
        }
      }
    });
    
    console.log('🔄 [TICKETS LISTADO] Tickets generados:', tickets);
    
    return tickets;
  }

  /**
   * Genera los medios de pago para la devolución según la nueva API
   */
  private generarMediosPagoDevolucionParcial(): any[] {
    const mediosPago = [];
    // Obtener el valor actual del pago desglosado
    const pagoDesglosado = this.devolucionService.pagoDesglosadoValue || {};
    const albaran = this.albaranValue;
    const totalDevolucion = Math.abs(this.devolucionService.carritoDevolucion.precioTotal);
    
    console.log('🔄 [MEDIOS PAGO] ===== INICIO GENERACIÓN MEDIOS DE PAGO =====');
    console.log('🔄 [MEDIOS PAGO] pagoDesglosado:', pagoDesglosado);
    console.log('🔄 [MEDIOS PAGO] albaran.AlbaranFOPs:', albaran.AlbaranFOPs);
    console.log('🔄 [MEDIOS PAGO] totalDevolucion:', totalDevolucion);

    // CORRECCIÓN: Priorizar SIEMPRE los valores del formulario (frontend)
    // Verificar si el usuario ingresó valores en el formulario
    const metalicoNum = Number(pagoDesglosado.metalico || pagoDesglosado.efectivo) || 0;
    const pinpadNum = Number(pagoDesglosado.pinpad) || 0;
    const datafonoNum = Number(pagoDesglosado.datafono) || 0;
    const monederoNum = Number(pagoDesglosado.monedero) || 0;
    const transferenciaNum = Number(pagoDesglosado.transferencia) || 0;
    const aplazadoNum = Number(pagoDesglosado.aplazado) || 0;
    const prepagoNum = Number(pagoDesglosado.prepago) || 0;
    const simpeNum = Number(pagoDesglosado.simpe) || 0;
    
    const totalFormulario = metalicoNum + pinpadNum + datafonoNum + monederoNum + 
                           transferenciaNum + aplazadoNum + prepagoNum + simpeNum;
    
    const tieneValoresFormulario = totalFormulario > 0;

    if (tieneValoresFormulario) {
      console.log('✅ [MEDIOS PAGO] Usando valores del formulario (frontend) - prioridad absoluta');
      
      if (metalicoNum > 0) {
        console.log('✅ [MEDIOS PAGO] Agregando CA:', metalicoNum);
        mediosPago.push({
          FOP: 'CA',
          Importe: metalicoNum.toFixed(2)
        });
      }

      const totalCC = pinpadNum + datafonoNum;
      if (totalCC > 0) {
        console.log('✅ [MEDIOS PAGO] Agregando CC:', totalCC, '(pinpad:', pinpadNum, ', datafono:', datafonoNum, ')');
        mediosPago.push({
          FOP: 'CC',
          Importe: totalCC.toFixed(2)
        });
      }

      if (monederoNum > 0) {
        console.log('✅ [MEDIOS PAGO] Agregando TM:', monederoNum);
        mediosPago.push({
          FOP: 'TM',
          Importe: monederoNum.toFixed(2)
        });
      }

      if (transferenciaNum > 0) {
        console.log('✅ [MEDIOS PAGO] Agregando TR:', transferenciaNum);
        mediosPago.push({
          FOP: 'TR',
          Importe: transferenciaNum.toFixed(2)
        });
      }

      if (aplazadoNum > 0) {
        console.log('✅ [MEDIOS PAGO] Agregando DP:', aplazadoNum);
        mediosPago.push({
          FOP: 'DP',
          Importe: aplazadoNum.toFixed(2)
        });
      }

      if (prepagoNum > 0) {
        console.log('✅ [MEDIOS PAGO] Agregando PR:', prepagoNum);
        mediosPago.push({
          FOP: 'PR',
          Importe: prepagoNum.toFixed(2)
        });
      }

      if (simpeNum > 0) {
        console.log('✅ [MEDIOS PAGO] Agregando SP:', simpeNum);
        mediosPago.push({
          FOP: 'SP',
          Importe: simpeNum.toFixed(2)
        });
      }

      console.log('✅ [MEDIOS PAGO] Medios de pago generados desde formulario:', mediosPago);
      console.log('🔄 [MEDIOS PAGO] ===== FIN GENERACIÓN MEDIOS DE PAGO =====');
      return mediosPago;
    }

    // Si no hay valores en el formulario, usar la lógica automática (solo como fallback)
    console.log('⚠️ [MEDIOS PAGO] No hay valores en formulario, usando lógica automática');

    // Verificar si hay pago múltiple en el albarán original
    const fopsConImporte = albaran.AlbaranFOPs.filter(fop => {
      const importe = Number.parseFloat(fop.ImportePendiente?.toString().replace(/,/, '.') || '0');
      return importe > 0;
    });
    
    const tienePagoMultiple = this.conf.DatosResult.AppConfigJsonPago.PagoMultiple == '1' &&
                              albaran.AlbaranFOPs && 
                              albaran.AlbaranFOPs.length >= 2 &&
                              fopsConImporte.length >= 2;

    console.log('🔍 [MEDIOS PAGO] Análisis de pago múltiple:', {
      'PagoMultiple config': this.conf.DatosResult.AppConfigJsonPago.PagoMultiple,
      'AlbaranFOPs.length': albaran.AlbaranFOPs?.length || 0,
      'fopsConImporte.length': fopsConImporte.length,
      'tienePagoMultiple': tienePagoMultiple,
      'fopsConImporte': fopsConImporte.map(fop => ({
        FOP: fop.FOP,
        ImportePendiente: fop.ImportePendiente,
        ImportePendienteNum: Number.parseFloat(fop.ImportePendiente?.toString().replace(/,/, '.') || '0')
      }))
    });

    // Si hay pago múltiple, verificar primero si se puede devolver solo en el medio prioritario
    if (tienePagoMultiple) {
      console.log('🔄 [MEDIOS PAGO] Pago múltiple detectado');
      
      // CORRECCIÓN CASO 02: Identificar el medio de pago prioritario
      // Orden de prioridad: CA > CC > TM > TR > DP > PR > SP
      const ordenPrioridad = ['CA', 'CC', 'TM', 'TR', 'DP', 'PR', 'SP'];
      let fopPrioritario = null;
      let importePrioritario = 0;
      
      console.log('🔍 [MEDIOS PAGO] Buscando medio de pago prioritario...');
      for (const fopCode of ordenPrioridad) {
        const fop = albaran.AlbaranFOPs.find(x => x.FOP === fopCode);
        if (fop) {
          const importe = Number.parseFloat(fop.ImportePendiente?.toString().replace(/,/, '.') || '0');
          console.log(`🔍 [MEDIOS PAGO] Evaluando ${fopCode}:`, {
            'FOP': fopCode,
            'ImportePendiente (raw)': fop.ImportePendiente,
            'ImportePendiente (num)': importe,
            'esMayorQue0': importe > 0
          });
          if (importe > 0) {
            fopPrioritario = fop;
            importePrioritario = importe;
            console.log('✅ [MEDIOS PAGO] Medio prioritario encontrado:', {
              'FOP': fopPrioritario.FOP,
              'ImportePendiente': importePrioritario
            });
            break;
          }
        }
      }
      
      if (!fopPrioritario) {
        console.log('⚠️ [MEDIOS PAGO] No se encontró medio prioritario, usando distribución proporcional');
      } else {
        // CORRECCIÓN CASO 02: Si el total a devolver no supera el importe del medio prioritario,
        // devolver solo en ese medio (no distribuir proporcionalmente)
        console.log('🔍 [MEDIOS PAGO] Verificando si devolución puede cubrirse solo con medio prioritario:', {
          'totalDevolucion': totalDevolucion,
          'importePrioritario': importePrioritario,
          'fopPrioritario': fopPrioritario.FOP,
          'puedeCubrirseSolo': totalDevolucion <= importePrioritario
        });
        
        if (totalDevolucion <= importePrioritario) {
          console.log('✅ [MEDIOS PAGO] DECISIÓN: Devolver solo en medio prioritario');
          console.log('✅ [MEDIOS PAGO] Razón: totalDevolucion (', totalDevolucion, ') <= importePrioritario (', importePrioritario, ')');
          
          mediosPago.push({
            FOP: fopPrioritario.FOP,
            Importe: totalDevolucion.toFixed(2)
          });
          
          console.log('✅ [MEDIOS PAGO] Medios de pago generados (solo prioritario):', mediosPago);
          console.log('🔄 [MEDIOS PAGO] ===== FIN GENERACIÓN MEDIOS DE PAGO =====');
          return mediosPago;
        } else {
          console.log('🔄 [MEDIOS PAGO] DECISIÓN: Distribuir proporcionalmente');
          console.log('🔄 [MEDIOS PAGO] Razón: totalDevolucion (', totalDevolucion, ') > importePrioritario (', importePrioritario, ')');
        }
      }
      
      // Si la devolución supera el medio prioritario, distribuir proporcionalmente
      console.log('🔄 [MEDIOS PAGO] Iniciando distribución proporcional...');
      
      // Calcular el total pendiente de todos los medios de pago
      let totalPendiente = 0;
      albaran.AlbaranFOPs.forEach(fop => {
        const importe = Number.parseFloat(fop.ImportePendiente?.toString().replace(/,/, '.') || '0');
        if (importe > 0) {
          totalPendiente += importe;
        }
      });
      
      console.log('🔍 [MEDIOS PAGO] Total pendiente calculado:', totalPendiente);

      // Distribuir proporcionalmente el total a devolver entre los medios de pago
      let totalDistribuido = 0;

      fopsConImporte.forEach((fop, index) => {
        const importePendiente = Number.parseFloat(fop.ImportePendiente?.toString().replace(/,/, '.') || '0');
        if (importePendiente > 0) {
          // Calcular la proporción de este medio de pago
          const proporcion = importePendiente / totalPendiente;
          let importeDevolucion = totalDevolucion * proporcion;
          
          console.log(`🔍 [MEDIOS PAGO] Calculando para ${fop.FOP}:`, {
            'importePendiente': importePendiente,
            'proporcion': proporcion,
            'importeDevolucion (inicial)': importeDevolucion,
            'esUltimo': index === fopsConImporte.length - 1
          });
          
          // Asegurar que no se devuelva más de lo pendiente
          if (importeDevolucion > importePendiente) {
            importeDevolucion = importePendiente;
            console.log(`⚠️ [MEDIOS PAGO] ${fop.FOP}: Ajustado a importePendiente (${importePendiente})`);
          }
          
          // Solo incluir si el importe es mayor que 0
          if (importeDevolucion > 0) {
            // Para el último medio de pago, ajustar para que la suma sea exacta
            if (index === fopsConImporte.length - 1) {
              const importeAnterior = importeDevolucion;
              importeDevolucion = totalDevolucion - totalDistribuido;
              console.log(`🔍 [MEDIOS PAGO] ${fop.FOP} (último): Ajustando para suma exacta:`, {
                'importeAnterior': importeAnterior,
                'totalDevolucion': totalDevolucion,
                'totalDistribuido': totalDistribuido,
                'importeDevolucion (ajustado)': importeDevolucion
              });
              // Asegurar que no sea negativo ni mayor que el pendiente
              if (importeDevolucion < 0) {
                importeDevolucion = 0;
              }
              if (importeDevolucion > importePendiente) {
                importeDevolucion = importePendiente;
              }
            }
            
            totalDistribuido += importeDevolucion;
            
            // Mapear el FOP al formato correcto
            let fopCode = fop.FOP;
            if (fopCode === 'CC') {
              // Para tarjeta, usar el mismo código CC
              fopCode = 'CC';
            }
            
            mediosPago.push({
              FOP: fopCode,
              Importe: importeDevolucion.toFixed(2)
            });
            
            console.log(`✅ [MEDIOS PAGO] Agregando ${fopCode}:`, importeDevolucion.toFixed(2));
          }
        }
      });
      
      console.log('🔍 [MEDIOS PAGO] Resumen distribución proporcional:', {
        'totalDevolucion': totalDevolucion,
        'totalDistribuido': totalDistribuido,
        'diferencia': totalDevolucion - totalDistribuido,
        'mediosPagoGenerados': mediosPago
      });
      
      // Si después de la distribución proporcional no se cubrió todo, usar el pago desglosado como respaldo
      if (totalDistribuido < totalDevolucion && pagoDesglosado && Object.keys(pagoDesglosado).length > 0) {
        console.log('🔄 [MEDIOS PAGO] Usando pago desglosado como complemento');
        const diferencia = totalDevolucion - totalDistribuido;
        
        // Buscar en pagoDesglosado qué medio de pago tiene valor
        const metalicoNum = Number(pagoDesglosado.metalico || pagoDesglosado.efectivo) || 0;
        const pinpadNum = Number(pagoDesglosado.pinpad) || 0;
        const datafonoNum = Number(pagoDesglosado.datafono) || 0;
        const totalCC = pinpadNum + datafonoNum;
        
        console.log('🔍 [MEDIOS PAGO] Valores pagoDesglosado para complemento:', {
          'metalicoNum': metalicoNum,
          'pinpadNum': pinpadNum,
          'datafonoNum': datafonoNum,
          'totalCC': totalCC,
          'diferencia': diferencia
        });
        
        if (totalCC > 0 && !mediosPago.find(mp => mp.FOP === 'CC')) {
          mediosPago.push({
            FOP: 'CC',
            Importe: Math.min(totalCC, diferencia).toFixed(2)
          });
          console.log('✅ [MEDIOS PAGO] Agregado CC como complemento:', Math.min(totalCC, diferencia).toFixed(2));
        } else if (metalicoNum > 0 && !mediosPago.find(mp => mp.FOP === 'CA')) {
          mediosPago.push({
            FOP: 'CA',
            Importe: Math.min(metalicoNum, diferencia).toFixed(2)
          });
          console.log('✅ [MEDIOS PAGO] Agregado CA como complemento:', Math.min(metalicoNum, diferencia).toFixed(2));
        }
      }
    } else {
      // Si no hay pago múltiple, usar la lógica original
      if (!pagoDesglosado || Object.keys(pagoDesglosado).length === 0) {
        console.log('🔄 [MEDIOS PAGO] No hay pago desglosado, usando lógica de InsercionVenta');
        
        // Pago simple - usar el total de la devolución
        mediosPago.push({
          FOP: albaran.FOP || 'CA',
          Importe: totalDevolucion.toFixed(2)
        });
      } else {
        // Usar el pago desglosado del formulario
        console.log('🔍 [MEDIOS PAGO] Evaluando pagoDesglosado completo:', pagoDesglosado);
        
        const metalicoNum = Number(pagoDesglosado.metalico || pagoDesglosado.efectivo) || 0;
        if (metalicoNum > 0) {
          console.log('✅ [MEDIOS PAGO] Agregando CA:', metalicoNum);
          mediosPago.push({
            FOP: 'CA',
            Importe: metalicoNum.toFixed(2)
          });
        }

        const pinpadNum = Number(pagoDesglosado.pinpad) || 0;
        const datafonoNum = Number(pagoDesglosado.datafono) || 0;
        const totalCC = pinpadNum + datafonoNum;
        if (totalCC > 0) {
          console.log('✅ [MEDIOS PAGO] Agregando CC:', totalCC, '(pinpad:', pinpadNum, ', datafono:', datafonoNum, ')');
          mediosPago.push({
            FOP: 'CC',
            Importe: totalCC.toFixed(2)
          });
        }

        const monederoNum = Number(pagoDesglosado.monedero) || 0;
        if (monederoNum > 0) {
          console.log('✅ [MEDIOS PAGO] Agregando TM:', monederoNum);
          mediosPago.push({
            FOP: 'TM',
            Importe: monederoNum.toFixed(2)
          });
        }

        const transferenciaNum = Number(pagoDesglosado.transferencia) || 0;
        if (transferenciaNum > 0) {
          console.log('✅ [MEDIOS PAGO] Agregando TR:', transferenciaNum);
          mediosPago.push({
            FOP: 'TR',
            Importe: transferenciaNum.toFixed(2)
          });
        }

        const aplazadoNum = Number(pagoDesglosado.aplazado) || 0;
        if (aplazadoNum > 0) {
          console.log('✅ [MEDIOS PAGO] Agregando DP:', aplazadoNum);
          mediosPago.push({
            FOP: 'DP',
            Importe: aplazadoNum.toFixed(2)
          });
        }

        const prepagoNum = Number(pagoDesglosado.prepago) || 0;
        if (prepagoNum > 0) {
          console.log('✅ [MEDIOS PAGO] Agregando PR:', prepagoNum);
          mediosPago.push({
            FOP: 'PR',
            Importe: prepagoNum.toFixed(2)
          });
        }

        const simpeNum = Number(pagoDesglosado.simpe) || 0;
        if (simpeNum > 0) {
          console.log('✅ [MEDIOS PAGO] Agregando SP:', simpeNum);
          mediosPago.push({
            FOP: 'SP',
            Importe: simpeNum.toFixed(2)
          });
        }
      }
    }

    // Fallback final: si no hay medios de pago, usar el total como metálico
    if (mediosPago.length === 0) {
      console.log('🔄 [MEDIOS PAGO] Fallback: usando total como metálico');
      mediosPago.push({
        FOP: 'CA',
        Importe: totalDevolucion.toFixed(2)
      });
    }

    console.log('✅ [MEDIOS PAGO] Medios de pago generados (final):', mediosPago);
    console.log('🔄 [MEDIOS PAGO] ===== FIN GENERACIÓN MEDIOS DE PAGO =====');
    return mediosPago;
  }

  /**
   * Calcula el cambio recibido del cliente
   * CORRECCIÓN: CambioRecibido SOLO se inicializa si al devolver se inserta alguna cantidad en el input EFECTIVO
   * Este campo representa el efectivo recibido del cliente durante la devolución
   */
  private calcularCambioRecibido(): number {
    // Obtener el valor actual del pago desglosado
    const pagoDesglosado = this.devolucionService.pagoDesglosadoValue || {};
    
    // CORRECCIÓN: CambioRecibido SOLO se inicializa si hay cantidad en el input EFECTIVO
    const efectivoRecibido = pagoDesglosado.efectivo || 0;
    
    console.log('🔄 [CALCULAR_CAMBIO_RECIBIDO] Valores:', {
      pagoDesglosado,
      efectivoRecibido,
      'pagoDesglosado.efectivo': pagoDesglosado.efectivo
    });

    // SOLO inicializar si hay cantidad en efectivo
    const resultado = efectivoRecibido > 0 ? Number.parseFloat(efectivoRecibido.toString()) : 0;
    console.log('✅ [CALCULAR_CAMBIO_RECIBIDO] CambioRecibido (efectivo recibido):', resultado);
    return resultado;
  }

  /**
   * Calcula el cambio devuelto al cliente
   * CORRECCIÓN: CambioDevuelto SOLO se inicializa si al hacer la devolución existe alguna cantidad en efectivo (METALICO + EFECTIVO)
   * El cambio devuelto es el importe exacto en metálico que se le retornará al comprador
   */
  private calcularCambioDevuelto(): number {
    // Obtener el valor actual del pago desglosado
    const pagoDesglosado = this.devolucionService.pagoDesglosadoValue || {};
    const cambioValue = this.devolucionService.cambioValue || 0;
    const precioTotalDevolucion = Math.abs(this.devolucionService.carritoDevolucion.precioTotal);
    
    // Calcular la cantidad total en efectivo (METALICO + EFECTIVO)
    const efectivoTotal = (pagoDesglosado.metalico || 0) + (pagoDesglosado.efectivo || 0);
    
    console.log('🔄 [CALCULAR_CAMBIO_DEVUELTO] Valores:', {
      cambioValue,
      precioTotalDevolucion,
      pagoDesglosado,
      efectivoTotal,
      'pagoDesglosado.metalico': pagoDesglosado.metalico,
      'pagoDesglosado.efectivo': pagoDesglosado.efectivo,
      esPagoMultiple: this.conf.DatosResult.AppConfigJsonPago.PagoMultiple == '1' && 
                      this.albaranValue.AlbaranFOPs.length >= 2
    });

    // CORRECCIÓN: CambioDevuelto SOLO se inicializa si existe alguna cantidad en efectivo
    // Si no hay efectivo (metalico + efectivo = 0), devolver 0
    if (efectivoTotal <= 0) {
      console.log('✅ [CALCULAR_CAMBIO_DEVUELTO] No hay efectivo, CambioDevuelto = 0');
      return 0;
    }
    
    // Si hay efectivo, usar el cambioValue calculado o el precioTotalDevolucion como fallback
    const resultado = cambioValue || precioTotalDevolucion;
    
    console.log('✅ [CALCULAR_CAMBIO_DEVUELTO] Cambio devuelto:', resultado);
    return resultado;
  }

  /**
   * Genera las operaciones de tarjeta para la devolución (versión completa)
   */
  private generarOperacionesTarjetaDevolucionCompleta(IdentificadorOrigen?, pedido?, RTS?, MCPComercio?, MCPTerminal?): any {
    const albaran = this.albaranValue;
    // Obtener el valor actual del pago desglosado
    const pagoDesglosado = this.devolucionService.pagoDesglosadoValue || {};

    console.log('🔍 [OPERACIONES_TARJETA] Generando OperacionesTarjeta con IdentificadorOrigen:', IdentificadorOrigen);

    // Calcular importe según la lógica de InsercionVenta
    let importe = 0;
    if (this.conf.DatosResult.AppConfigJsonPago.PagoMultiple != '1' ||
        this.albaranValue.AlbaranFOPs.length < 2) {
      importe = this.devolucionService.carritoDevolucion.precioTotal;
    } else {
      const fopCC = this.devolucionService.generarMediosPagoVenta().find((fop) => fop.FOP === 'CC');
      importe = fopCC ? fopCC.Importe * -1 : 0;
    }
    
    const operacionesTarjeta = {
      FechaHora: '',
      Importe: importe,
      TipoOperacion: '02',
      NumAutorizacion2oBloque: '',
      CodigoAceptacion: 'AC',
      TextoInformativo: 'OPERACION ACEPTADA',
      TextoReservadoControlador: '',
      NumTarjeta: albaran.PagoCCInfo?.NumTarjeta || '',
      FechaCaducidad: albaran.PagoCCInfo?.FechaCaducidad || '',
      NumAutorizacion1erBloque: '',
      FechaConciliacion1erBloque: '',
      FechaConciliacion2oBloque: '',
      TieneLector: albaran.PagoCCInfo?.TieneLectorElectronico === 'True' ? '1' : '0',
      LecturaElectronica: albaran.PagoCCInfo?.TieneLectorElectronico === 'True' ? '1' : '0',
      PresenciaTitular: '1',
      TarjetaPresente: '1',
      TipoTarjeta: '',
      NumOperacion: pedido || '',
      IdentEstablecimiento2oBloque: MCPComercio || '',
      DatosAdicionales: RTS || '',
      DatosAdicionalesPrivados: MCPTerminal || '',
      CodigoAccion: '',
      PedidoBase: '',
      CodigoClienteID: '',
      NumReimpresiones: '',
      IntroduccionManual: '',
      DivisaId: albaran.DivisaId || '',
      // CORRECCIÓN: Inicializar Identificador con el chIdentificador del albarán original
      // Identificador: Nº pedido de la venta origen mandado a la pasarela bancaria para realizar la devolución
      Identificador: IdentificadorOrigen || ''
    };
    
    console.log('✅ [OPERACIONES_TARJETA] Objeto OperacionesTarjeta generado:', {
      'Identificador': operacionesTarjeta.Identificador,
      'Importe': operacionesTarjeta.Importe,
      'TipoOperacion': operacionesTarjeta.TipoOperacion,
      'NumTarjeta': operacionesTarjeta.NumTarjeta,
      'objeto completo': operacionesTarjeta
    });
    
    return operacionesTarjeta;
  }

  /**
   * Genera las operaciones de tarjeta para la devolución (versión simple)
   */
  private generarOperacionesTarjetaDevolucion(): any {
    const albaran = this.albaranValue;
    // Obtener el valor actual del pago desglosado
    const pagoDesglosado = this.devolucionService.pagoDesglosadoValue || {};
    
    return {
      TipoOperacion: '02', // Abono
      Importe: (pagoDesglosado.pinpad + pagoDesglosado.datafono).toString(),
      CodigoAceptacion: 'AC',
      TextoInformativo: 'OPERACION ACEPTADA',
      TextoReservadoControlador: '',
      NumTarjeta: albaran.PagoCCInfo?.NumTarjeta || '',
      FechaCaducidad: albaran.PagoCCInfo?.FechaCaducidad || '',
      TieneLector: albaran.PagoCCInfo?.TieneLectorElectronico === 'True' ? '1' : '0',
      LecturaElectronica: albaran.PagoCCInfo?.TieneLectorElectronico === 'True' ? '1' : '0',
      PresenciaTitular: '1',
      TarjetaPresente: '1',
      TipoTarjeta: '',
      NumOperacion: '',
      IdentEstablecimiento2oBloque: '',
      DatosAdicionales: '',
      DatosAdicionalesPrivados: '',
      PedidoBase: '',
      CodigoClienteID: '0',
      IntroduccionManual: '0',
      DivisaId: albaran.DivisaId
    };
  }

  generarBruto(entradas) {
    let bruto = 0;
    entradas.forEach((entrada) => {
      bruto =
        bruto +
        +entrada.itemInfo.PrecioBase.replace(/,/, '.') *
          +entrada.itemInfo.Cantidad; //Yaribel 20210225 Multiplicamos por cantidad para incluir las ventas con OrdenConjunta
    });
    bruto = bruto * -1;
    const brutoString = bruto.toString();
    return brutoString;
  }

  generarTotal(entradas) {
    let total = 0;
    entradas.forEach((entrada) => {
      total =
        total +
        +entrada.itemInfo.PrecioUnidad.replace(/,/, '.') *
          +entrada.itemInfo.Cantidad; //Yaribel 20210225 Multiplicamos por cantidad para incluir las ventas con OrdenConjunta
    });
    total = total * -1;
    const totalString = total.toString();
    return totalString;
  }

  private generarResumenTurno() {
    return {
      TurnoId: this.turnoService.turnoValue.pkid,
      UsuarioId: this.turnoService.turnoValue.UsuarioId,
      TPVId: this.turnoService.turnoValue.TpvId,
      NumEntradas: this.devolucionService.carritoDevolucion.cantidadTotal * -1,
      IngresoAlbaranes:
        this.devolucionService.carritoDevolucion.precioTotal * -1,
    };
  }

  private generarEntradasDevolucion(itemsDevolucion): any[] {
    /*       const precioUnidad = Number.parseFloat(ticket.itemInfo.PrecioUnidad.replace(/,/, '.')) * -1;
      const baseImponible = Number.parseFloat(ticket.itemInfo.PrecioBase.replace(/,/, '.')) * -1;
      const comision = Number.parseFloat(ticket.itemInfo.Comision.replace(/,/, '.')) * -1 || 0;
      const ivaComision =
        Number.parseFloat(ticket.itemInfo.IvaComision.replace(/,/, '.')) * -1 || 0;

      this.devolucionService.comision = comision; */
    const entradas = [];
    itemsDevolucion.forEach((item) => {
      if (true) {
        if (item.itemInfo.TipoProducto === '2') {
          item.itemInfo.PromocionEntradas.forEach((entrada, index) => {
            //<<Yaribel 20210224 Añadimos comprobacion de orden conjunta (añadimos todas las entras de ese item) y QRPromo (añadimos las entradas de esa promo))
            // let totalTicket = item.tickets.length;
            // if((item.tickets[0].ImprimirQRPromo == '1' ||item.tickets[0].ImprimirQRPromo == "True"))
            // {
            //   totalTicket = item.tickets.length * item.itemInfo.PromocionEntradas.length;
            // }
            // if (index < item.tickets.length) {
            //Yaribel 20210224 >>
            const nuevaEntrada = {
              PrecioPagado: -Math.abs(
                Number.parseFloat(entrada.PrecioTotal.replace(/,/, '.'))
              ) /*-
                  (-Math.abs(
                    Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
                  ) || 0)*/,
              DivisaId: this.albaranValue.DivisaDevueltaId,
              NumOrden: entrada.NumeroEntradas,
              NombreTipo: entrada.NombreTipo,
              TipoEntradaId: entrada.TipoEntradaId,
              FechaHoraEntrada: item.itemInfo.FechaHoraEntrada,
              Operacion: 'RF',
              BaseImponible: -Math.abs(
                Number.parseFloat(entrada.PrecioBase.replace(/,/, '.'))
              ),
              IVA: entrada.IVA,
              Devuelta: '0',
              TipoAbreviado: item.itemInfo.TipoAbreviado || '',
              iNumAlbaran: this.albaranValue.NumAlbaran,
              AbonadoId: '0',
              ClienteAsociadoId: '0',
              OrdenCjta: 0,
              Comision:
                -Math.abs(
                  Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
                ) || 0,
              IvaComision: item.itemInfo.IvaComision,
              BonoTexto: item.itemInfo.BonoTexto || '',
              DNIAbonadosExt: item.itemInfo.DNIAbonadosExt || '',
              Identificacion: item.itemInfo.Identificacion || '',
              CodigoTipoControl: 0,
              BarCode: '',
              PromocionId: item.itemInfo.ItemId,
              PromocionNombre: item.itemInfo.NombreTipo,
              PromocionNumOrden: entrada.NumOrdenPromo,
              TarjetaMonederoCodigo: entrada.TarjetaMonederoCodigo || '', // Yaribel 13112020 añadios TarjetaMonederocodigo si lo tenemos
            };

            // if(+item.tickets[0].OrdenCjta > 0)
            // {
            //   if (item.tickets[0].ImprimirQRPromo == '1' || item.tickets[0].ImprimirQRPromo == "True"){
            //     entradas.push(nuevaEntrada);
            //   } else {
            //     if(item.tickets[0].ItemId  == entrada.TipoEntradaId)
            //     {
            //       entradas.push(nuevaEntrada);
            //     }
            //   }

            // } else {
            //   if (item.tickets[0].ImprimirQRPromo == '1' || item.tickets[0].ImprimirQRPromo == "True"){
            //     if(item.tickets[0].NumOrdenPromo == entrada.NumOrdenPromo){
            //       entradas.push(nuevaEntrada);
            //   }
            // }
            // }
            entradas.push(nuevaEntrada);
            // } // Yaribel 20210224
          });
        } else if (item.itemInfo.TipoProducto === '1') {
          //<< Yaribel 20210225 Añadimos un bucle para añadir el total de entradas de las ventas (si es orden Conjunta vienen juntas)
          let cantidadEntradas = item.itemInfo.Cantidad;
          for (let index = 0; index < cantidadEntradas; index++) {
            const nuevaEntrada = {
              PrecioPagado:
                -Math.abs(
                  Number.parseFloat(
                    item.itemInfo.PrecioUnidad.replace(/,/, '.')
                  )
                ) -
                (-Math.abs(
                  Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
                ) || 0),
              DivisaId: this.albaranValue.DivisaDevueltaId,
              NumOrden: +item.numTickets + index, //Generamos el numOrden a partir del primero que viene en la información
              NombreTipo: item.itemInfo.NombreTipo,
              TipoEntradaId: item.tickets[0].ItemId,
              FechaHoraEntrada: item.itemInfo.FechaHoraEntrada,
              Operacion: 'RF',
              BaseImponible: -Math.abs(
                Number.parseFloat(item.itemInfo.PrecioBase.replace(/,/, '.'))
              ),
              IVA: item.itemInfo.IVA,
              Devuelta: '0',
              TipoAbreviado: item.itemInfo.TipoAbreviado || '',
              iNumAlbaran: this.albaranValue.NumAlbaran,
              AbonadoId: '0',
              ClienteAsociadoId: '0',
              OrdenCjta: item.tickets[0].OrdenCjta || 0,
              Comision:
                -Math.abs(
                  Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
                ) || 0,
              IvaComision: item.itemInfo.IvaComision || '',

              BonoTexto: item.itemInfo.BonoTexto || '',
              DNIAbonadosExt: item.itemInfo.DNIAbonadosExt || '',
              Identificacion: item.itemInfo.Identificacion || '',
              CodigoTipoControl: item.tickets[0].CodigoTipoControl || '',
              BarCode: item.tickets[0].BarCode || '',
              TarjetaMonederoCodigo: item.itemInfo.TarjetaMonederoCodigo || '', // Yaribel 13112020 añadios TarjetaMonederocodigo si lo tenemos
              EntradasVendidasButacas:
                item.tickets[0].hasOwnProperty('EspectaculosImprimir') &&
                item.tickets[0].EspectaculosImprimir !== null
                  ? this.generarEntradasVendidasButacas(item)
                  : undefined,
            };

            entradas.push(nuevaEntrada);
          }
        }
      } else {
        if (item.itemInfo.TipoProducto === '2') {
          item.itemInfo.PromocionEntradas.forEach((entrada, index) => {
            if (index < item.tickets.length) {
              const nuevaEntrada = {
                PrecioPagado: -Math.abs(
                  Number.parseFloat(entrada.PrecioTotal.replace(/,/, '.'))
                ) /*-
                (-Math.abs(
                  Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
                ) || 0)*/,
                DivisaId: this.albaranValue.DivisaDevueltaId,
                NumOrden: entrada.NumeroEntradas,
                NombreTipo: entrada.NombreTipo,
                TipoEntradaId: entrada.TipoEntradaId,
                FechaHoraEntrada: item.itemInfo.FechaHoraEntrada,
                Operacion: 'RF',
                BaseImponible: -Math.abs(
                  Number.parseFloat(entrada.PrecioBase.replace(/,/, '.'))
                ),
                IVA: entrada.IVA,
                Devuelta: '0',
                TipoAbreviado: item.itemInfo.TipoAbreviado || '',
                iNumAlbaran: this.albaranValue.NumAlbaran,
                AbonadoId: '0',
                ClienteAsociadoId: '0',
                OrdenCjta: 0,
                Comision:
                  -Math.abs(
                    Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
                  ) || 0,
                IvaComision: item.itemInfo.IvaComision,
                BonoTexto: item.itemInfo.BonoTexto || '',
                DNIAbonadosExt: item.itemInfo.DNIAbonadosExt || '',
                Identificacion: item.itemInfo.Identificacion || '',
                CodigoTipoControl: 0,
                BarCode: '',
                PromocionId: item.itemInfo.ItemId,
                PromocionNombre: item.itemInfo.NombreTipo,
                PromocionNumOrden: entrada.NumOrdenPromo,
                TarjetaMonederoCodigo: entrada.TarjetaMonederoCodigo || '', // Yaribel 13112020 añadios TarjetaMonederocodigo si lo tenemos
              };
              entradas.push(nuevaEntrada);
            }
          });
        } else if (item.itemInfo.TipoProducto === '1') {
          const nuevaEntrada = {
            PrecioPagado:
              -Math.abs(
                Number.parseFloat(item.itemInfo.PrecioUnidad.replace(/,/, '.'))
              ) -
              (-Math.abs(
                Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
              ) || 0),
            DivisaId: this.albaranValue.DivisaDevueltaId,
            NumOrden: item.numTickets,
            NombreTipo: item.itemInfo.NombreTipo,
            TipoEntradaId: item.tickets[0].ItemId,
            FechaHoraEntrada: item.itemInfo.FechaHoraEntrada,
            Operacion: 'RF',
            BaseImponible: -Math.abs(
              Number.parseFloat(item.itemInfo.PrecioBase.replace(/,/, '.'))
            ),
            IVA: item.itemInfo.IVA,
            Devuelta: '0',
            TipoAbreviado: item.itemInfo.TipoAbreviado || '',
            iNumAlbaran: this.albaranValue.NumAlbaran,
            AbonadoId: '0',
            ClienteAsociadoId: '0',
            OrdenCjta: item.tickets[0].OrdenCjta || 0,
            Comision:
              -Math.abs(
                Number.parseFloat(item.itemInfo.Comision.replace(/,/, '.'))
              ) || 0,
            IvaComision: item.itemInfo.IvaComision || '',
            BonoTexto: item.itemInfo.BonoTexto || '',
            DNIAbonadosExt: item.itemInfo.DNIAbonadosExt || '',
            Identificacion: item.itemInfo.Identificacion || '',
            CodigoTipoControl: item.tickets[0].CodigoTipoControl || '',
            BarCode: item.tickets[0].BarCode || '',
            TarjetaMonederoCodigo: item.itemInfo.TarjetaMonederoCodigo || '', // Yaribel 13112020 añadios TarjetaMonederocodigo si lo tenemos
            EntradasVendidasButacas:
              item.tickets[0].hasOwnProperty('EspectaculosImprimir') &&
              item.tickets[0].EspectaculosImprimir !== null
                ? this.generarEntradasVendidasButacas(item)
                : undefined,
          };
          entradas.push(nuevaEntrada);
        }
      }
    });
    return entradas;

    /*     return {
      // tslint:disable-next-line:max-line-length
      PrecioPagado: -Math.abs(Number.parseFloat(item.itemInfo.PrecioUnidad)) - comision,
      DivisaId: this.albaranValue.DivisaDevueltaId,
      NumOrden: ticket.NumTicket,
      NombreTipo: ticket.itemInfo.NombreTipo,
      FechaHoraEntrada: ticket.itemInfo.FechaHoraEntrada,
      Operacion: 'RF',
      BaseImponible: baseImponible,
      IVA: ticket.itemInfo.IVA,
      Devuelta: ticket.Devuelta,
      TipoAbreviado: ticket.itemInfo.TipoAbreviado || '',
      iNumAlbaran: this.albaranValue.NumAlbaran,
      AbonadoId: ticket.itemInfo.AbonadoId || 0,
      ClienteAsociadoId: ticket.itemInfo.AsociadoId || 0,
      OrdenCjta: ticket.OrdenCjta || 0,
      Comision: comision,
      IvaComision: ivaComision,
      BonoTexto: ticket.itemInfo.BonoTexto || '',
      DNIAbonadosExt: ticket.itemInfo.DNIAbonadosExt || '',
      Identificacion: ticket.itemInfo.Identificacion || '',
      CodigoTipoControl: ticket.CodigoTipoControl,
      BarCode: ticket.BarCode,
      TipoEntradaId: ticket.ItemId
    }; */
  }

  generarEntradasVendidasButacas(entrada) {
    return {
      EspectaculoId: entrada.tickets[0].EspectaculosImprimir.EspectaculoId,
      RecintoId: entrada.tickets[0].recintosImprimir[0].RecintoId,
      FechaHora: entrada.tickets[0].recintosImprimir[0].FechaHoraEntrada,
      Fila: entrada.tickets[0].EspectaculosImprimir.NumFila,
      Butaca: entrada.tickets[0].EspectaculosImprimir.NumButaca,
    };
  }

  generarRecintosVenta(entradas) {
    let recintos = [];
    if (entradas.length > 0) {
      entradas.forEach((entrada) => {
        if ('EspectaculosImprimir' in entrada) {
          recintos.push({
            TipoSesionId: '', // butaca.IdTipoSesion,
            TipoEntradaId: entrada.tickets[0].ItemId,
            recintoId: entrada.tickets[0].recintosImprimir[0].RecintoId,
            fechaEntrada:
              entrada.tickets[0].recintosImprimir[0].FechaHoraEntrada,
            EspectaculoId:
              entrada.tickets[0].EspectaculosImprimir.EspectaculoId,
          });
        }
      });
    }

    recintos = recintos.filter(
      (recinto, index, self) =>
        index ===
        self.findIndex(
          (r) =>
            r.TipoEntradaId === recinto.TipoEntradaId &&
            r.recintoId === recinto.recintoId &&
            r.fechaEntrada === recinto.fechaEntrada
        )
    );

    return recintos;
  }

  private generarAforosDevolucion(entradas) {
    // Apaño para cadiz, no devolver aforos
    const aforos = {};
    let values = {};
    if (entradas.length > 0) {
      entradas.forEach((entrada) => {
        if ('EspectaculosImprimir' in entrada) {
          if (this.albaranValue.AlbaranRecintos) {
            const recinto = this.albaranValue.AlbaranRecintos.find(
              (r) => r.ItemId === entrada.ItemId
            );
            const cantidad = aforos[recinto.ItemId]
              ? aforos[recinto.ItemId].Cantidad
              : 0;
            aforos[recinto.ItemId] = {
              RecintoId: recinto.RecintoId,
              FechaHora: recinto.FechaEntrada,
              Cantidad: cantidad + 1,
            };
          }
        }
      });
      values = Object.values(aforos).map((aforo: any) => {
        aforo.Cantidad = aforo.Cantidad * -1;
        return aforo;
      });
    }
    return values;
  }

  private generarMediosPagoVenta() {
    return this.albaranValue.AlbaranFOPs.map((fop) => {
      const importe = this.devolucionService.carritoDevolucion.precioTotal * -1;
      return {
        FOP: fop.FOP,
        Importe: importe,
        TarjetaMonederoCodigo: fop.TarjetaMonederoCodigo,
      }; //Yaribel 11112020 Modificamos para que devuelva el Codigo de la tarjeta monedero
    });
  }

  private generarMediosPagoVentaAnulacion() {
    console.log({
      albaranFops: this.albaranValue.AlbaranFOPs,
    });
    return this.albaranValue.AlbaranFOPs.map((fop) => {
      const importeParsed = fop.Importe ? fop.Importe.replace(/,/, '.') : '0';
      const importe = parseFloat(importeParsed) * -1;
      return {
        FOP: fop.FOP,
        Importe: importe,
        TarjetaMonederoCodigo: fop.TarjetaMonederoCodigo,
        AlbaranId: fop.AlbaranId || null,
        CVaccance: [],
        Cheques: [],
      };
    });
  }

  generarIdentificadores(tpvId, prefijo) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      Plataforma: '2',
      Prefijo: prefijo,
      TpvId: tpvId,
    };
    return this.http.post(
      `${this.config.getConfig(
        'API_URL'
      )}api/VentaTaquilla/GenerarNumAlbaranIdentificador`,
      body
    );
  }

  generarOperacionTarjeta(albaran) {
    /*
    const body = {
      FechaHora: moment().format('YYYY/MM/DD HH:mm:ss'),
      Importe: this.venta.carritoValue.precioTotal,
      TipoOperacion: '01',
      NumAutorizacion2oBloque: '',
      CodigoAceptacion: 'AC', // TODO control de otros codigos
      TextoInformativo: this.operacionesTarjetaValue.resultado,
      TextoReservadoControlador: this.operacionesTarjetaValue.codigoRespuesta,
      NumTarjeta: this.operacionesTarjetaValue.tarjetaClienteRecibo,
      FechaCaducidad: this.operacionesTarjetaValue.caducidad,
      NumAutorizacion1erBloque: '',
      FechaConciliacion1erBloque: '',
      FechaConciliacion2oBloque: '',
      TieneLector: '1',
      LecturaElectronica: '1',
      PresenciaTitular: '1',
      TarjetaPresente: '1',
      TipoTarjeta: this.operacionesTarjetaValue.etiquetaApp,
      NumOperacion: this.operacionesTarjetaValue.pedido,
      IdentEstablecimiento2oBloque: this.operacionesTarjetaValue.comercio,
      DatosAdicionales: this.operacionesTarjetaValue.identificadorRTS,
      DatosAdicionalesPrivados: this.operacionesTarjetaValue.terminal,
      CodigoAccion: '',
      PedidoBase: this.operacionesTarjetaValue.pedido,
      CodigoClienteID: '',
      NumReimpresiones: '1',
      IntroduccionManual: '0',
      DivisaId: this.turnoService.turnoValue.DivisaId
    };
    return body; */
  }

  createToken() {
    const currentToken = this.tokenManager.getTaquillaToken();
    if (!currentToken || !currentToken) {
      return throwError('No hay token de sesión disponible');
    }
    return of({ token: currentToken });
  }

  reimprimirTicketsAlbaran(numAlbaran, idAlbaran) {
    return this.createToken().pipe(
      switchMap((token) => {
        const conexionId = JSON.parse(localStorage.getItem('conexionId'));
        const idioma = this.translate.getLocale();
        const idiomaParam = `idioma=${idioma}`;
        const tpvIdParam = `tpvId=${this.turnoService.turnoValue.TpvId}`;
        const numAlbaranParam = numAlbaran;
        const plataformaParam = 'plataforma=2';
        const usuarioId = `usuarioId=${this.turnoService.turnoValue.UsuarioId}`;

        const headers = {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Credentials': 'true',
          'Access-Control-Allow-Headers': 'Content-Type',
          'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE',
          Authorization: `Bearer ${token.token}`,
          'IAC-Connection-String': this.config.getConfig('chClaveEmpresa'),
        };

        // Retornamos la solicitud HTTP dentro del switchMap
        return this.http
          .get(
            `${this.config.getConfig(
              'API_URL_TAQUILLA'
            )}/api/Ticket/GenerarPDF?conexionId=${conexionId}&${idiomaParam}&${tpvIdParam}&${numAlbaranParam}&${plataformaParam}&${usuarioId}`,
            { headers: headers, responseType: 'json' }
          )
          .pipe(
            map((response: { datos: string }) => response.datos),
            tap((pdfBase64) => {
              this.printPDFWithBase64(pdfBase64);
            })
          );
      })
    );
  }
  printPDFWithBase64(base64: string, fileName: string = 'ticket.pdf') {
    const binaryData = atob(base64);

    const arrayBuffer = new ArrayBuffer(binaryData.length);
    const uint8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < binaryData.length; i++) {
      uint8Array[i] = binaryData.charCodeAt(i) & 0xff;
    }

    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(blobUrl);
  }

  pad(s, size) {
    while (s.length < (size || 2)) {
      s = '0' + s;
    }
    return s;
  }

  private generarAforosVenta(): any {
    let res = [];
    if (this.albaranValue.AlbaranRecintos) {
      this.albaranValue.AlbaranRecintos.forEach((recinto) => {
        if (recinto.EspectaculoId === '0') {
          if (recinto.ControlaAforoVenta === '1' && recinto.Periodo == '0') {
            res.push({
              RecintoId: recinto.RecintoId,
              FechaHora: recinto.FechaEntrada,
              // Cantidad: Number.parseInt(recinto.Cantidad, 10) * -1,
              Cantidad: Number.parseInt(recinto.Cantidad, 10) * -1,
              EsVentaTaquilla: this.albaranValue.Localizador ? '0' : '1',
            });
          }
        }
      });
      res = res.filter(
        (recinto, index, self) =>
          index ===
          self.findIndex(
            (r) =>
              r.RecintoId === recinto.RecintoId &&
              r.FechaHora === recinto.FechaHora &&
              r.Cantidad === recinto.Cantidad &&
              r.EsVentaTaquilla === recinto.EsVentaTaquilla
          )
      );

      res.forEach((element) => {
        let cant = 0;
        this.albaranValue.AlbaranRecintos.forEach((e) => {
          if (
            e.RecintoId === element.RecintoId &&
            e.FechaEntrada === element.FechaHora
          )
            cant += +e.Cantidad;
        });
        element.Cantidad = cant.toString();
      });
    }
    return res;
  }

  getAlbaranxNum(idTpv, numAlbaran) {
    const conexionId = JSON.parse(localStorage.getItem('conexionId'));
    const body = {
      ConexionIacpos: conexionId,
      TPVId: idTpv,
      NumAlbaran: numAlbaran,
      Pagina: '1',
      NumeroRegistros: '1',
    };
    this.http
      .post(`${this.config.getConfig('API_URL')}api/GetDatosAlbaran`, body)
      .pipe(
        map((res: any) => {
          if (res.DatosResult === null) {
            // Preservar el NumAlbaran original para permitir navegación
            const currentAlbaran = this.albaranValue;
            this.setAlbaranValue({ 
              noData: true, 
              NumAlbaran: currentAlbaran ? currentAlbaran.NumAlbaran : '' 
            });
            return;
          }
          //<<Yaribel 20210217  Añadimos filtro para que no se nos dupliquen las entradas
          if (
            res.DatosResult &&
            res.DatosResult.ListadoAlbaranInfo[0] &&
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems
          ) {
            let newAlbaranItems: AlbaranItem[] = [];
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems.forEach(
              (element) => {
                let datos: AlbaranItem = newAlbaranItems.find(
                  (item) =>
                    item.ItemId === element.ItemId &&
                    item.TipoProducto === element.TipoProducto &&
                    item.PrecioUnidad === element.PrecioUnidad
                );
                if (datos === null || datos === undefined) {
                  const nuevo = { ...element, Contactos: [] };
                  nuevo.Contactos.push(element.idContacto);
                  newAlbaranItems.push(nuevo);
                } else {
                  datos.Cantidad = +datos.Cantidad + +element.Cantidad + '';
                  datos.CantidadMaxima =
                    +datos.CantidadMaxima + +element.CantidadMaxima + '';
                  datos.PrecioTotal =
                    +datos.PrecioTotal + +element.PrecioTotal + '';
                }
              }
            );
            res.DatosResult.ListadoAlbaranInfo[0].AlbaranItems =
              newAlbaranItems;
          }
          // Yaribel 20210217 >>
          this.setAlbaranValue({
            ...res.DatosResult.ListadoAlbaranInfo[0],
            noData: false,
            NombreTPV: this.turnoService.turnoValue.NombreTPV,
            IdTPV: this.turnoService.turnoValue.TpvId, // Yaribel 20210315 Añadimos el pkid del tpv actual
          });
        })
      )
      .subscribe();
  }
}
